import axiosClient from 'api/axiosClient';
import store from 'app/store';
import { AgencyConstants } from 'features/Agency/agencyHelper';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import * as Yup from 'yup';
import DialogActivateChargeConnectorView from './ChargeConnector/components/DialogActivateChargeConnectorView';
import DialogLockSlotDoorView from './ChargeConnector/components/DialogLockSlotDoorView';
import DialogOpenSlotDoorView from './ChargeConnector/components/DialogOpenSlotDoorView';
import DialogStopSlotChargingView from './ChargeConnector/components/DialogStopSlotChargingView';
import DialogStartSlotChargingView from './ChargeConnector/components/DialogStartSlotChargingView';
import DialogWarningThresholdSlotView from './ChargeConnector/components/DialogWarningThresholdSlotView';
import DialogDisableSlotView from './ChargeConnector/components/DialogDisableSlotView';
import DialogAddBatteryToSlotView from './ChargeConnector/components/DialogAddBatteryToSlotView';
import DialogTopUpDriverView from './ChargeDriver/components/DialogTopUpDriverView';
import DialogTransactionDetailView from './ChargeDriver/components/DialogTransactionDetailView';
import ChargePointSetLimitPowerView from './ChargePoint/components/ChargePointSetLimitPowerView';
import DialogMovePointView from './ChargePoint/components/DialogMovePointView';
import DialogReportErrorChargePointView from './ChargePoint/components/DialogReportErrorChargePointView';
import DialogScheduledMaintenanceCabinetView from './ChargePoint/components/DialogScheduledMaintenanceCabinetView';
import DialogWarningThresholdCabinetView from './ChargePoint/components/DialogWarningThresholdCabinetView';
import DialogChangeRfidCardView from './ChargeRFID/components/DialogChangeRfidCardView';
import DialogStopChargeStationView from './ChargeStation/components/DialogStopChargeStationView';
import DialogSetChargingPriceView from './ChargeDriver/components/DialogSetChargingPriceView';
import DialogChangeAgencyPasswordView from 'features/ManageDealer/components/DialogChangeAgencyPasswordView';
import DialogDownloadExcelFile from 'features/System/Excel/components/DialogDownloadExcelFile';

// MARK: ---- CONSTANTS ----
export const ChargeConstants = {
  // ---- USER ----
  UserRole: {
    ADMIN: 'ADMIN', // Quản trị viên
    OPERATOR: 'OPERATOR', // Nhà điều hành
    AGENCY: 'AGENCY', // Đại lý
    DRIVER: 'DRIVER', // Khách hàng
    MAINTAINER: 'MAINTAINER', // Người bảo trì
  },
  // ---- KHACH HANG ----
  ChargeDriverStatus: {
    REGISTERED: 'REGISTERED', // Đã đăng ký
    NORMAL: 'NORMAL', // Đang hoạt động
    SUSPENDED: 'SUSPENDED', // Ngừng hoạt động
    DELETED: 'DELETED', // Đã xóa
  },

  ChargeDriverPricingType: {
    STANDARD: 'STANDARD', // Tiêu chuẩn
    DISCOUNT: 'DISCOUNT', // Ưu đãi
    FREE: 'FREE', // Miễn phí
  },

  // ---- THE RFID ----
  RFIDCardStatus: {
    NORMAL: 'NORMAL', // Đang hoạt động
    BLOCKED: 'BLOCKED', // Bị khóa
  },

  // ---- TRAM SAC ----
  // trang thai tram sac
  ChargeStationStatus: {
    NORMAL: 'NORMAL', // Đang hoạt động
    MAINTAINING: 'MAINTAINING', // Đang bảo trì
    PENDING: 'PENDING', // Đang lắp đặt
    STOPPED: 'STOPPED', // Ngừng hoạt động
    HIDDEN: 'HIDDEN', // Đang ẩn
  },

  // ---- TRU SAC ----
  ChargePointStatus: {
    AVAILABLE: 'AVAILABLE', // Sẵn sàng
    BUSY: 'BUSY', // Đang bận
    FAULT: 'FAULT', // Lỗi
    MAINTAINING: 'MAINTAINING', // Đang bảo trì
    DISCONNECTED: 'DISCONNECTED', // Mất kết nối
    DISABLED: 'DISABLED', // Vô hiệu hóa
    SMOKE_WARNING: 'SMOKE_WARNING', // Cảnh báo khói
    WATER_WARNING: 'WATER_WARNING', // Cảnh báo ngập nước
  },
  ChargePointType: {
    AC: 'AC', // AC
    DC: 'DC', // DC
  },

  // ---- VOI SAC ----
  ChargeConnectorStatus: {
    AVAILABLE: 'AVAILABLE', // Sẵn sàng
    PREPARING: 'PREPARING', // Đang chuẩn bị
    CHARGING: 'CHARGING', // Đang sạc
    SUSPENDED: 'SUSPENDED', // Đang tạm dừng
    FINISHING: 'FINISHING', // Đang kết thúc
    FAULTED: 'FAULTED', // Lỗi
  },
  ChargeConnectorType: {
    J1772: 'J1772',
    Mennekes: 'Mennekes',
    GB_T: 'GB/T',
    CHAdeMO: 'CHAdeMO',
    CCS1: 'CCS1',
    CCS2: 'CCS2',
    Tesla: 'Tesla',
    AC: 'AC',
  },

  // ---- THONG BAO ----
  MessageLogType: {
    INFO: 'INFO', // Thông tin
    NOTICE: 'NOTICE', // Thông báo
    WARNING: 'WARNING', // Cảnh báo
    ERROR: 'ERROR', // Lỗi
  },
  NotificationCategory: {
    BUSINESS: 'BUSINESS', // Kinh doanh
    OPERATION: 'OPERATION', // Vận hành
    PROMOTION: 'PROMOTION', // Khuyến mãi
    CHARGE: 'CHARGE', // Sạc xe & Giao dịch
    OTHER: 'OTHER', // Khác
    EVG: 'EVG', // EVG
  },
  NotificationStatus: {
    SCHEDULED: 'SCHEDULED', // Đã lên lịch
    SENT: 'SENT', // Đã gửi
  },

  // ---- DINH GIA SAC ----
  ChargePricingMode: {
    FLAT: 'FLAT', // Cố định
    HOURS: 'HOURS', // Theo giờ
    TIERED: 'TIERED', // Bậc thang
  },

  // ---- PHUONG THUC THANH TOAN ----
  ChargePaymentMethod: {
    WALLET: 'WALLET', // Ví điện tử
    CASH: 'CASH', // Tiền mặt
    QR: 'QR', // QR Code
    VNPAY: 'VNPAY', // VNPAY
    MOMO: 'MOMO', // MOMO
    INTERNAL: 'INTERNAL', // INTERNAL
  },

  // ---- PHIEN SAC ----
  ChargeTransactionStatus: {
    INITIATING: 'INITIATING', // Khởi tạo
    PREPARING: 'PREPARING', // Chuẩn bị, voi sac da cam
    CHARGING: 'CHARGING', // Dang sac
    FINISHING: 'FINISHING', // Dang ket thuc, chua rut voi sac
    FINISHED: 'FINISHED', // Da ket thuc
    CANCELLED: 'CANCELLED', // Da huy
    FAILED: 'FAILED', // Loi
  },

  // ---- PHIEN DOI PIN ----
  SwapSessionStatus: {
    FINISHED: 'FINISHED', // Đã kết thúc
    BATTERY_RETURNED: 'BATTERY_RETURNED', // Đã trả pin
    BATTERY_PICKED_UP: 'BATTERY_PICKED_UP', // Đã lấy pin
    INITIATING: 'INITIATING', // Đang khởi tạo
    WAITING_PICK_UP: 'WAITING_PICK_UP', // Chờ lấy pin
    WAITING_RETURN: 'WAITING_RETURN', // Chờ trả pin
    PICK_UP_EXPIRED: 'PICK_UP_EXPIRED', // Hết thời gian lấy pin
    FAILED: 'FAILED', // Lỗi
    CANCELLED: 'CANCELLED', // Đã hủy
  },

  // ---- KHAC ----
  VehicleType: {
    CAR: 'CAR',
    BIKE: 'BIKE',
  },
  EnergyAccountStatus: {
    PENDING: 'PENDING', // Chờ xác nhận
    VALIDATED: 'VALIDATED', // Đã xác nhận
  },
  VehicleStatus: {
    NORMAL: 'NORMAL', // Đang hoạt động
    DELETED: 'DELETED', // Đã xóa
    PENDING: 'PENDING', // Chờ xác nhận
  },
  ChargePaymentStatus: {
    PENDING: 'PENDING', // Chờ xác nhận
    COMPLETED: 'COMPLETED', // Đã thanh toán
    FAILED: 'FAILED', // Thất bại
    CANCELLED: 'CANCELLED', // Đã hủy
  },
  WalletTransactionStatus: {
    QUEUED: 'QUEUED', //Đang đợi
    PENDING: 'PENDING', //Đang xử lý
    COMPLETED: 'COMPLETED', //Hoàn thành
    CANCELLED: 'CANCELLED', //Đã hủy
  },
  DashboardRevenueType: {
    INVESTOR: 'INVESTOR',
    GROUP: 'GROUP',
    ENERGY: 'ENERGY',
    CHARGEPOINT: 'CHARGEPOINT',
  },
  TutorialStatus: {
    NORMAL: 'NORMAL',
    DELETED: 'DELETED',
  },
  TutorialObject: {
    DRIVER: 'DRIVER',
    AGENCY: 'AGENCY',
  },
  networkOperator: {
    VIETTEL: 'VIETTEL',
    VINAPHONE: 'VINAPHONE',
  },
  InputPhase: {
    THREE_PHASE: '3_PHASE', // 3 pha
    TWO_PHASE: '2_PHASE', // 2 pha
    ONE_PHASE: '1_PHASE', // 1 pha
  },
};

const ChargeHelper = {
  // MARK: ---- FILTER ----
  Filter: {
    chargeStationList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
      operatorId: '',
      search: '',
      agencyId: '',
      landlordId: '',
      areaId: '',
      vehicleType: '',
      chargePointType: '',
      cabinetType: '',
      from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
      selectedValue: dateFilter.tatCaThoiGian,
    },
    chargeTransactionList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      stationId: '',
      vehicleType: '',
      isTestTransaction: 0,
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
    },
    chargeBrandList: {
      search: '',
      page: 0,
      limit: 10,
    },
    cabinetBrandList: {
      search: '',
      page: 0,
      limit: 10,
      status: '',
    },
    chargeModelList: {
      search: '',
      page: 0,
      limit: 10,
    },
    chargeVehicleBrandList: {
      q: '',
      vehicleType: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
    },
    chargeVehicleModelList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
    },
    chargeVehicleList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      vehicleType: '',
      brandId: '',
      modelId: '',
      status: '',
      object: '',
    },
    chargeRfidList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      status: '',
    },
    chargeDriverList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      driverType: '',
      ekycVerified: '',
      status: '',
      discountType: '',
    },
    batteryList: {
      page: 1,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      isOnline: '',
      batteryType: '',
      chargeSwitch: '',
      dischargeSwitch: '',
      from: '',
      to: '',
      selectedValue: '',
    },
    systemLogList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      category: '',
      userId: '',
      createdBy: 'SYSTEM',
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      isSent: '',
    },
    chargePricingList: {
      q: '',
      page: 1,
      limit: AppConfigs.defaultPageLimit,
      operatorId: '',
      agencyId: '',
      pointId: '',
    },
    driverTopUpHistoryList: {
      userId: '',
      q: '',
      page: 1,
      limit: AppConfigs.defaultPageLimit,
      status: '',
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      direction: 'IN',
    },
  },

  // MARK: ---- VALIDATION SCHEMA ----
  ValidationSchema: {
    // ---- TRAM SAC ----
    chargeStation: Yup.object({
      monthlyPremiseCost: Yup.number().nullable(),
      energyCost: Yup.number().nullable(),
      currency: Yup.string().nullable(),
      status: Yup.string().required('Vui lòng chọn trạng thái'),
      name: Yup.string().required('Vui lòng nhập tên trạm đổi pin'),
      description: Yup.string().nullable(),
      address: Yup.string().required('Vui lòng nhập địa chỉ cụ thể'),
      phone: Yup.string()
        .required('Vui lòng nhập số điện thoại trạm đổi pin')
        .test('len', 'Số điện thoại không hợp lệ', (val) => {
          if (val) {
            return !val.toString().includes(' ') && val.toString().match(AppConfigs.regex.phone);
          }
        }),
      operatorId: Yup.string().required('Vui lòng chọn nhà điều hành'),
      agencyId: Yup.number().nullable(),
      landlordId: Yup.number().nullable(),
      latitude: Yup.string().nullable(),
      longitude: Yup.string().nullable(),
      image: Yup.string().nullable(),
      services: Yup.array().nullable(),
      contactName: Yup.string().required('Vui lòng nhập tên người quản lý trạm đổi pin'),
      contactPhone: Yup.string()
        .required('Vui lòng nhập số điện thoại người quản lý')
        .test('len', 'Số điện thoại không hợp lệ', (val) => {
          if (val) {
            return !val.toString().includes(' ') && val.toString().match(AppConfigs.regex.phone);
          }
        }),
      isAgencyPayEnergyCost: Yup.string().required('Vui lòng chọn đối tượng thanh toán'),
      inputFlatPrice: Yup.string()
        .when('inputPricingMode', {
          is: 'FLAT',
          then: Yup.string()
            .required('Vui lòng nhập giá điện cố định')
            .test(
              'is-valid-number',
              'Giá điện cố định phải là số lớn hơn 0',
              (value) => {
                const number = Number(value);
                return !isNaN(number) && number > 0;
              }
            ),
          otherwise: Yup.string().nullable().notRequired(),
        }),
      inputNormalPrice: Yup.string()
        .when('inputPricingMode', {
          is: 'HOURS',
          then: Yup.string()
            .required('Vui lòng nhập giá điện giờ bình thường')
            .test(
              'is-valid-number',
              'Giá điện giờ bình thường phải là số lớn hơn 0',
              (value) => {
                const number = Number(value);
                return !isNaN(number) && number > 0;
              }
            ),
          otherwise: Yup.string().nullable().notRequired(),
        }),
      inputPeakPrice: Yup.string()
        .when('inputPricingMode', {
          is: 'HOURS',
          then: Yup.string()
            .required('Vui lòng nhập giá điện giờ cao điểm')
            .test(
              'is-valid-number',
              'Giá điện giờ cao điểm phải là số lớn hơn 0',
              (value) => {
                const number = Number(value);
                return !isNaN(number) && number > 0;
              }
            ),
          otherwise: Yup.string().nullable().notRequired(),
        }),
      inputOffPeakPrice: Yup.string()
        .when('inputPricingMode', {
          is: 'HOURS',
          then: Yup.string()
            .required('Vui lòng nhập giá điện giờ thấp điểm')
            .test(
              'is-valid-number',
              'Giá điện giờ thấp điểm phải là số lớn hơn 0',
              (value) => {
                const number = Number(value);
                return !isNaN(number) && number > 0;
              }
            ),
          otherwise: Yup.string().nullable().notRequired(),
        }),
      inputTieredPrice: Yup.array()
        .when('inputPricingMode', {
          is: 'TIERED',
          then: Yup.array()
            .of(
              Yup.object().shape({
                upto: Yup.number().required('Vui lòng nhập mức tiêu thụ'),
                price: Yup.number()
                  .typeError('Giá phải là số')
                  .required('Vui lòng nhập số tiền')
                  .moreThan(0, 'Giá phải lớn hơn 0'),
              })
            )
            .min(1, 'Phải có ít nhất một mức giá')
            .test(
              'prices-not-decreasing',
              'Mỗi mức giá sau phải lớn hơn hoặc bằng mức giá trước',
              function (tieredPrices) {
                if (!Array.isArray(tieredPrices)) return true;

                for (let i = 1; i < tieredPrices.length; i++) {
                  const prev = Number(tieredPrices[i - 1]?.price);
                  const curr = Number(tieredPrices[i]?.price);

                  if (!isFinite(prev) || !isFinite(curr)) continue;

                  if (curr < prev) {
                    return this.createError({
                      path: `inputTieredPrice[${i}].price`,
                      message: `Giá tại mức thứ ${i + 1} phải lớn hơn hoặc bằng mức trước`,
                    });
                  }
                }

                return true;
              }
            ),
          otherwise: Yup.array().nullable().notRequired(),
        }),

    }),
    // ---- TRU SAC ----
    chargePoint: Yup.object({
      pointId: Yup.string().nullable(),
      power: Yup.number().nullable(),
      type: Yup.string().required('Vui lòng chọn loại trụ sạc'),
      modelId: Yup.string().required('Vui lòng chọn model'),
      phoneNumber: Yup.string()
        .nullable()
        .test('len', 'Số điện thoại không hợp lệ', (val) => {
          if (_.isNil(val) || val === '') return true;
          return !val.toString().includes(' ') && val.toString().match(AppConfigs.regex.phone);
        }),
      numberConnectors: Yup.number().required('Vui lòng nhập số lượng vòi sạc'),
      voltage: Yup.number().nullable(),
      maxAmpere: Yup.number().required('Vui lòng nhập dòng điện tối đa'),
      protocol: Yup.string().required('Vui lòng nhập giao thức'),
      ocppId: Yup.string().required('Vui lòng nhập OCPP ID'),
      ocppPassword: Yup.string().required('Vui lòng nhập OCPP Password'),
      image: Yup.string().nullable(),
      serialNumber: Yup.string().required('Vui lòng nhập số serial trụ sạc'),
      cabinetName: Yup.string().trim().required('Vui lòng nhập tên tủ pin'),
      iccid: Yup.string().nullable(),
      networkOperator: Yup.string().nullable(),
      dataPackage: Yup.string().nullable(),
      // pricing
      freeOverchargeDuration: Yup.number().min(0, 'Thời gian không hợp lệ'), //.required('Vui lòng nhập thời gian sạc miễn phí'),
      overchargePrice: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá sạc quá giờ'),
      pricingMode: Yup.string(), //.required('Vui lòng chọn cách tính giá'),
      flatPrice: Yup.number().when('pricingMode', {
        is: ChargeConstants.ChargePricingMode.FLAT,
        then: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá cố định'),
      }),
      normalPrice: Yup.number().when('pricingMode', {
        is: ChargeConstants.ChargePricingMode.HOURS,
        then: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá giờ bình thường'),
      }),
      peakPrice: Yup.number().when('pricingMode', {
        is: ChargeConstants.ChargePricingMode.HOURS,
        then: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá giờ cao điểm'),
      }),
      offPeakPrice: Yup.number().when('pricingMode', {
        is: ChargeConstants.ChargePricingMode.HOURS,
        then: Yup.number().min(0, 'Giá không hợp lệ'), //.required('Vui lòng nhập giá giờ thấp điểm'),
      }),
    }),
    // ---- HANG SAN XUAT TRU SAC ----
    chargeBrand: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên hãng sản xuất'),
      logo: Yup.string().required('Vui lòng chọn logo'),
      website: Yup.string().url('Địa chỉ website không hợp lệ').nullable(),
    }),
    // ---- MODEL TRU SAC ----
    chargeModel: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên model'),
      description: Yup.string().nullable(),
      image: Yup.string().required('Vui lòng chọn ảnh'),
      vehicleType: Yup.string().nullable(),
      type: Yup.string().required('Vui lòng chọn loại trụ sạc'),
      protocol: Yup.string().required('Vui lòng nhập giao thức'),
      batteryType: Yup.string()
        .required('Vui lòng chọn loại pin')
        .min(1, 'Vui lòng chọn loại pin'),
      power: Yup.number()
        .required('Vui lòng nhập công suất')
        .test('is-valid-number', 'Công suất phải lớn hơn 0', (value) =>
          value ? !isNaN(Number(value)) && Number(value) > 0 : false
        ),
      voltage: Yup.number()
        .required('Vui lòng nhập điện áp')
        .test('is-valid-number', 'Điện áp phải lớn hơn 0', (value) =>
          value ? !isNaN(Number(value)) && Number(value) > 0 : false
        ),
      price: Yup.number()
        .required('Vui lòng nhập đơn giá')
        .test('is-valid-number', 'Đơn giá phải lớn hơn 0', (value) =>
          value ? !isNaN(Number(value)) && Number(value) > 0 : false
        ),
    }),
    // ---- MODEL PIN TU SPEC ----
    batteryBrandModelFromSpec: Yup.object({
      specId: Yup.number()
        .required('Vui lòng chọn loại pin')
        .test('is-valid-number', 'Vui lòng chọn loại pin', (value) =>
          value != null && value !== undefined && value !== '' && !isNaN(Number(value))
        ),
      image: Yup.string().required('Vui lòng chọn ảnh'),
      description: Yup.string().nullable(),
    }),
    // ---- MODEL TU PIN ----
    cabinetBrandModel: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên dòng tủ pin'),
      description: Yup.string().nullable(),
      image: Yup.string().required('Vui lòng chọn ảnh'),
      totalSlots: Yup.string().required('Vui lòng chọn loại tủ pin'),
      batteryStandard: Yup.string().nullable(),
      supportedBatteryTypes: Yup.array()
        .min(1, 'Vui lòng chọn ít nhất một loại pin tương thích')
        .nullable(),
      maxChargePower: Yup.number()
        .required('Vui lòng nhập công suất sạc tối đa')
        .test('is-positive-integer', 'Công suất sạc tối đa phải là số nguyên lớn hơn 0', (value) => {
          if (value === undefined || value === null || value === '') return false;
          const numValue = Number(value);
          return !isNaN(numValue) && numValue > 0 && Number.isInteger(numValue);
        }),
      inputVoltage: Yup.number()
        .required('Vui lòng nhập điện áp đầu vào')
        .test('is-positive-integer', 'Điện áp đầu vào phải là số nguyên lớn hơn 0', (value) => {
          if (value === undefined || value === null || value === '') return false;
          const numValue = Number(value);
          return !isNaN(numValue) && numValue > 0 && Number.isInteger(numValue);
        }),
      inputPhase: Yup.string().required('Vui lòng chọn nguồn điện đầu vào'),
      protocol: Yup.string().required('Vui lòng nhập giao thức'),
      price: Yup.number()
        .required('Vui lòng nhập đơn giá')
        .test('is-valid-number', 'Đơn giá phải lớn hơn hoặc bằng 0', (value) =>
          value !== undefined && value !== null && value !== '' ? !isNaN(Number(value)) && Number(value) >= 0 : false
        ),
    }),
    // ---- HANG SAN XUAT XE ----
    chargeVehicleBrand: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên hãng xe'),
      logo: Yup.string().required('Vui lòng chọn logo'),
      vehicleTypes: Yup.string().required('Vui lòng chọn loại phương tiện'),
    }),
    // ---- DONG XE ----
    chargeVehicleModel: Yup.object({
      name: Yup.string().required('Vui lòng nhập tên hãng xe'),
      image: Yup.string().required('Vui lòng chọn ảnh'),
      description: Yup.string().nullable(),
      batteryCapacity: Yup.string().required('Vui lòng nhập dung lượng pin'),
      connectorType: Yup.string().nullable(),
    }),
  },

  // MARK: ---- DATA ----
  Data: {
    // ---- RFID ----
    chargeRfidStatusOptions: [
      { value: ChargeConstants.RFIDCardStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.RFIDCardStatus.BLOCKED, name: 'Bị khóa' },
    ],
    // ---- TRAM SAC ----
    chargeStationStatusOptions: [
      { value: ChargeConstants.ChargeStationStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.ChargeStationStatus.MAINTAINING, name: 'Đang bảo trì' },
      { value: ChargeConstants.ChargeStationStatus.PENDING, name: 'Đang lắp đặt' },
      { value: ChargeConstants.ChargeStationStatus.STOPPED, name: 'Ngừng hoạt động' },
      { value: ChargeConstants.ChargeStationStatus.HIDDEN, name: 'Đang ẩn' },
    ],
    // ---- TRU SAC ----
    chargePointStatusOptions: [
      { value: ChargeConstants.ChargePointStatus.AVAILABLE, name: 'Sẵn sàng' },
      { value: ChargeConstants.ChargePointStatus.BUSY, name: 'Đang bận' },
      { value: ChargeConstants.ChargePointStatus.FAULT, name: 'Lỗi' },
      { value: ChargeConstants.ChargePointStatus.MAINTAINING, name: 'Đang bảo trì' },
      { value: ChargeConstants.ChargePointStatus.DISCONNECTED, name: 'Mất kết nối' },
      { value: ChargeConstants.ChargePointStatus.DISABLED, name: 'Vô hiệu hóa' },
    ],
    chargePointTypeOptions: [
      { value: ChargeConstants.ChargePointType.AC, name: 'AC' },
      { value: ChargeConstants.ChargePointType.DC, name: 'DC' },
    ],
    chargePointNumberConnectorOptions: [
      { value: 1, name: '1 vòi sạc' },
      { value: 2, name: '2 vòi sạc' },
      { value: 3, name: '3 vòi sạc' },
      { value: 4, name: '4 vòi sạc' },
      { value: 5, name: '5 vòi sạc' },
      { value: 6, name: '6 vòi sạc' },
      { value: 7, name: '7 vòi sạc' },
      { value: 8, name: '8 vòi sạc' },
      { value: 9, name: '9 vòi sạc' },
      { value: 10, name: '10 vòi sạc' },
    ],
    // ---- VOI SAC ----
    chargeConnectorStatusOptions: [
      { value: ChargeConstants.ChargeConnectorStatus.AVAILABLE, name: 'Sẵn sàng' },
      { value: ChargeConstants.ChargeConnectorStatus.PREPARING, name: 'Đang chuẩn bị' },
      { value: ChargeConstants.ChargeConnectorStatus.CHARGING, name: 'Đang sạc' },
      { value: ChargeConstants.ChargeConnectorStatus.SUSPENDED, name: 'Đang tạm dừng' },
      { value: ChargeConstants.ChargeConnectorStatus.FINISHING, name: 'Đang kết thúc' },
    ],
    chargeConnectorTypeOptions: [
      {
        value: ChargeConstants.ChargeConnectorType.J1772,
        name: 'J1772 - Type 1',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`j1772Connector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.Mennekes,
        name: 'Mennekes - Type 2',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`mennekesConnector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.GB_T,
        name: 'GB/T',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`gbtPlug`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.CHAdeMO,
        name: 'CHAdeMO',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`chademoConnector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.CCS1,
        name: 'CCS1',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`ccs1Connector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.CCS2,
        name: 'CCS2',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`ccs2Connector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.Tesla,
        name: 'Tesla',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`teslaConnector`]}
          />
        ),
      },
      {
        value: ChargeConstants.ChargeConnectorType.AC,
        name: 'AC',
        iconEl: (
          <img
            className="w-30px h-30px"
            style={{ objectFit: 'contain' }}
            src={AppResource.images.chargeConnectorTypes[`acConnector`]}
          />
        ),
      },
    ],
    // ---- THONG BAO ----
    messageLogTypeOptions: [
      { value: ChargeConstants.MessageLogType.INFO, name: 'Thông tin' },
      { value: ChargeConstants.MessageLogType.NOTICE, name: 'Thông báo' },
      { value: ChargeConstants.MessageLogType.WARNING, name: 'Cảnh báo' },
      { value: ChargeConstants.MessageLogType.ERROR, name: 'Lỗi' },
    ],
    vehicleTypeOptions: [
      { value: ChargeConstants.VehicleType.CAR, name: 'Ô tô' },
      { value: ChargeConstants.VehicleType.BIKE, name: 'Xe máy' },
    ],
    cabinetTypeOptions: [
      { value: '5', name: '5 ngăn' },
      { value: '8', name: '8 ngăn' },
      { value: '10', name: '10 ngăn' },
      { value: '12', name: '12 ngăn' },
      { value: '15', name: '15 ngăn' },
    ],
    batteryStandardOptions: [
      '60V 30AH',
      '60V 40AH',
      '72V 24AH',
      '76V 25AH',
      '72V 48AH',
    ],
    batteryTypeOptions: [
      { value: '60V 30AH', name: '60V 30AH' },
      { value: '60V 40AH', name: '60V 40AH' },
      { value: '72V 24AH', name: '72V 24AH' },
      { value: '76V 25AH', name: '76V 25AH' },
      { value: '72V 48AH', name: '72V 48AH' },
    ],
    inputPhaseOptions: [
      { value: ChargeConstants.InputPhase.THREE_PHASE, name: '3 pha' },
      { value: ChargeConstants.InputPhase.TWO_PHASE, name: '2 pha' },
      { value: ChargeConstants.InputPhase.ONE_PHASE, name: '1 pha' },
    ],
    networkOperatorOptions: [
      { value: 'VIETTEL', name: 'Viettel' },
      { value: 'VINAPHONE', name: 'Vinaphone' },
    ],
    chargePricingModeOptions: [
      { value: ChargeConstants.ChargePricingMode.HOURS, name: 'Theo khung giờ' },
      { value: ChargeConstants.ChargePricingMode.TIERED, name: 'Theo bậc thang' },
      { value: ChargeConstants.ChargePricingMode.FLAT, name: 'Đồng giá' },
    ],
    chargePricingStationModeOptions: [
      { value: ChargeConstants.ChargePricingMode.HOURS, name: 'Theo khung giờ' },
      { value: ChargeConstants.ChargePricingMode.TIERED, name: 'Theo bậc thang' },
    ],
    notificationCategoryOptions: [
      { value: ChargeConstants.NotificationCategory.BUSINESS, name: 'Kinh doanh' },
      { value: ChargeConstants.NotificationCategory.OPERATION, name: 'Vận hành' },
      { value: ChargeConstants.NotificationCategory.PROMOTION, name: 'Khuyến mãi' },
      { value: ChargeConstants.NotificationCategory.CHARGE, name: 'Sạc xe & Giao dịch' },
      { value: ChargeConstants.NotificationCategory.OTHER, name: 'Khác' },
      { value: ChargeConstants.NotificationCategory.EVG, name: 'EVG' },
    ],
    // ---- PHIEN SAC ----
    chargeTransactionStatusOptions: [
      { value: ChargeConstants.ChargeTransactionStatus.INITIATING, name: 'Khởi tạo' },
      { value: ChargeConstants.ChargeTransactionStatus.PREPARING, name: 'Chuẩn bị' },
      { value: ChargeConstants.ChargeTransactionStatus.CHARGING, name: 'Đang sạc' },
      { value: ChargeConstants.ChargeTransactionStatus.FINISHING, name: 'Đang kết thúc' },
      { value: ChargeConstants.ChargeTransactionStatus.FINISHED, name: 'Đã kết thúc' },
      { value: ChargeConstants.ChargeTransactionStatus.CANCELLED, name: 'Đã hủy' },
      { value: ChargeConstants.ChargeTransactionStatus.FAILED, name: 'Lỗi' },
    ],
    // ---- PHIEN DOI PIN ----
    swapSessionStatusOptions: [
      { value: ChargeConstants.SwapSessionStatus.FINISHED, name: 'Đã kết thúc' },
      { value: ChargeConstants.SwapSessionStatus.BATTERY_RETURNED, name: 'Đã trả pin' },
      { value: ChargeConstants.SwapSessionStatus.BATTERY_PICKED_UP, name: 'Đã lấy pin' },
      { value: ChargeConstants.SwapSessionStatus.INITIATING, name: 'Đang khởi tạo' },
      { value: ChargeConstants.SwapSessionStatus.WAITING_PICK_UP, name: 'Chờ lấy pin' },
      { value: ChargeConstants.SwapSessionStatus.WAITING_RETURN, name: 'Chờ trả pin' },
      { value: ChargeConstants.SwapSessionStatus.PICK_UP_EXPIRED, name: 'Hết thời gian lấy pin' },
      { value: ChargeConstants.SwapSessionStatus.FAILED, name: 'Lỗi' },
      { value: ChargeConstants.SwapSessionStatus.CANCELLED, name: 'Đã hủy' },
    ],
    // Dữ liệu mẫu danh sách phiên đổi pin (dùng ở danh sách phiên đổi pin & chi tiết tủ pin)
    mockSwapSessionList: [
      { swapSessionId: 1, swapSessionCode: 'BSW00000001', ownerName: 'Nguyễn Quốc Anh', phone: '01667565952', status: 'FINISHED', batteryInCode: 'BAT00000001', batteryInSoc: 5, batteryOutCode: 'BAT00000002', batteryOutSoc: 95, capacityDiffPercent: 90, energyDiffKwh: 1.8, serviceFeeVnd: 63000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
      { swapSessionId: 2, swapSessionCode: 'BSW00000002', ownerName: 'Lương Xuân Thanh', phone: '01292042096', status: 'BATTERY_RETURNED', batteryInCode: 'BAT00000003', batteryInSoc: 10, batteryOutCode: 'BAT00000004', batteryOutSoc: 92, capacityDiffPercent: 82, energyDiffKwh: 1.64, serviceFeeVnd: 57000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
      { swapSessionId: 3, swapSessionCode: 'BSW00000003', ownerName: 'Nguyễn Duy Khánh', phone: '0983043195', status: 'BATTERY_PICKED_UP', batteryInCode: 'BAT00000001', batteryInSoc: 2, batteryOutCode: 'BAT00000005', batteryOutSoc: 100, capacityDiffPercent: 98, energyDiffKwh: 1.96, serviceFeeVnd: 69000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
      { swapSessionId: 4, swapSessionCode: 'BSW00000004', ownerName: 'Dương Thúy Phương', phone: '0912345678', status: 'INITIATING', batteryInCode: 'BAT00000006', batteryInSoc: 25, batteryOutCode: 'BAT00000007', batteryOutSoc: 100, capacityDiffPercent: 75, energyDiffKwh: 1.5, serviceFeeVnd: 53000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
      { swapSessionId: 5, swapSessionCode: 'BSW00000005', ownerName: 'Nguyễn Thị Lễ', phone: '0987654321', status: 'WAITING_PICK_UP', batteryInCode: 'BAT00000008', batteryInSoc: 17, batteryOutCode: 'BAT00000009', batteryOutSoc: 100, capacityDiffPercent: 83, energyDiffKwh: 1.3, serviceFeeVnd: 48000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
      { swapSessionId: 6, swapSessionCode: 'BSW00000006', ownerName: 'Quế Ngọc Hải', phone: '0123456789', status: 'WAITING_RETURN', batteryInCode: 'BAT00000010', batteryInSoc: 37, batteryOutCode: 'BAT00000002', batteryOutSoc: 100, capacityDiffPercent: 63, energyDiffKwh: 1.26, serviceFeeVnd: 44000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
      { swapSessionId: 7, swapSessionCode: 'BSW00000007', ownerName: 'Phạm Ngọc Quỳnh Anh', phone: '0909123456', status: 'PICK_UP_EXPIRED', batteryInCode: 'BAT00000011', batteryInSoc: 37, batteryOutCode: 'BAT00000012', batteryOutSoc: 100, capacityDiffPercent: 63, energyDiffKwh: 1.28, serviceFeeVnd: 44000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
      { swapSessionId: 8, swapSessionCode: 'BSW00000008', ownerName: 'Nguyễn Đức Thọ', phone: '0376543210', status: 'FAILED', batteryInCode: 'BAT00000013', batteryInSoc: 15, batteryOutCode: 'BAT00000014', batteryOutSoc: 100, capacityDiffPercent: 85, energyDiffKwh: 1.7, serviceFeeVnd: 60000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
      { swapSessionId: 9, swapSessionCode: 'BSW00000009', ownerName: 'Văn Thái Dương', phone: '0898765432', status: 'CANCELLED', batteryInCode: 'BAT00000015', batteryInSoc: 50, batteryOutCode: 'BAT00000016', batteryOutSoc: 100, capacityDiffPercent: 50, energyDiffKwh: 1, serviceFeeVnd: 35000, startTime: '2020-07-26T11:11:30', endTime: '2020-07-26T11:11:30', plate: '29AA-12345', vehicleModelName: 'Vinfast Feliz' },
    ],
    // ---- XE ----
    vehicleStatusOptions: [
      { value: ChargeConstants.VehicleStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.VehicleStatus.DELETED, name: 'Đã xóa' },
      { value: ChargeConstants.VehicleStatus.PENDING, name: 'Chờ xác nhận' },
    ],
    // ---- RFID ----
    rfidCardStatusOptions: [
      { value: ChargeConstants.RFIDCardStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.RFIDCardStatus.BLOCKED, name: 'Bị khóa' },
    ],
    // ---- KHACH HANG ----
    chargeDriverStatusOptions: [
      { value: ChargeConstants.ChargeDriverStatus.REGISTERED, name: 'Chờ kích hoạt' },
      { value: ChargeConstants.ChargeDriverStatus.NORMAL, name: 'Đang hoạt động' },
      { value: ChargeConstants.ChargeDriverStatus.SUSPENDED, name: 'Ngừng hoạt động' },
      { value: ChargeConstants.ChargeDriverStatus.DELETED, name: 'Đã xóa' },
    ],
    chargeDriverPricingTypeOptions: [
      { value: ChargeConstants.ChargeDriverPricingType.STANDARD, name: 'Tiêu chuẩn' },
      { value: ChargeConstants.ChargeDriverPricingType.DISCOUNT, name: 'Ưu đãi' },
      { value: ChargeConstants.ChargeDriverPricingType.FREE, name: 'Miễn phí' },
    ],
    // ---- PAYMENT ----
    chargePaymentStatusOptions: [
      { value: ChargeConstants.ChargePaymentStatus.PENDING, name: 'Chờ xác nhận' },
      { value: ChargeConstants.ChargePaymentStatus.COMPLETED, name: 'Đã thanh toán' },
      { value: ChargeConstants.ChargePaymentStatus.FAILED, name: 'Thất bại' },
    ],
    chargePaymentMethodOptions: [
      { value: ChargeConstants.ChargePaymentMethod.WALLET, name: 'Ví điện tử' },
      { value: ChargeConstants.ChargePaymentMethod.CASH, name: 'Tiền mặt' },
      { value: ChargeConstants.ChargePaymentMethod.QR, name: 'QR Code' },
      { value: ChargeConstants.ChargePaymentMethod.VNPAY, name: 'VNPAY' },
      { value: ChargeConstants.ChargePaymentMethod.MOMO, name: 'MOMO' },
      { value: ChargeConstants.ChargePaymentMethod.INTERNAL, name: 'Nạp nội bộ' },
    ],
    // ---- WALLET TRANSACTION ----
    walletTransactionStatusOptions: [
      { value: ChargeConstants.WalletTransactionStatus.QUEUED, name: 'Đang đợi' },
      { value: ChargeConstants.WalletTransactionStatus.PENDING, name: 'Đang xử lý' },
      { value: ChargeConstants.WalletTransactionStatus.COMPLETED, name: 'Hoàn thành' },
      { value: ChargeConstants.WalletTransactionStatus.CANCELLED, name: 'Đã hủy' },
    ],
    // ---- DASHBOARD ----
    dashboardRevenueTypeOptions: [
      { value: ChargeConstants.DashboardRevenueType.GROUP, name: 'Bán gói đầu tư HTKD' },
      { value: ChargeConstants.DashboardRevenueType.INVESTOR, name: 'Bán nhượng quyền' },
      { value: ChargeConstants.DashboardRevenueType.CHARGEPOINT, name: 'Bán trụ sạc' },
    ],
    saleDashboardRevenueTypeOptions: [
      { value: ChargeConstants.DashboardRevenueType.GROUP, name: 'Bán gói đầu tư HTKD' },
      { value: ChargeConstants.DashboardRevenueType.INVESTOR, name: 'Bán nhượng quyền' },
      { value: ChargeConstants.DashboardRevenueType.CHARGEPOINT, name: 'Bán trụ sạc' },
    ],
    // ---- TUTORIAL ----
    tutorialObjectOptions: [
      { value: ChargeConstants.TutorialObject.DRIVER, name: 'Tài xế' },
      { value: ChargeConstants.TutorialObject.AGENCY, name: 'Đối tác' },
    ],
    tutorialStatusOptions: [
      { value: ChargeConstants.TutorialStatus.NORMAL, name: 'Hoạt động' },
      { value: ChargeConstants.TutorialStatus.DELETED, name: 'Đang ẩn' },
    ],
    // ---- INVENTORY ----
    inventoryUnitOptions: [
      { value: 'Bộ', name: 'Bộ' },
      { value: 'Cái', name: 'Cái' },
      { value: 'Chiếc', name: 'Chiếc' },
      { value: 'Gói', name: 'Gói' },
      { value: 'Mét', name: 'Mét' },
      { value: 'Thiết bị', name: 'Thiết bị' },
      { value: 'Tủ', name: 'Tủ' },
      { value: 'Dịch vụ', name: 'Dịch vụ' },
      { value: 'Hạng mục', name: 'Hạng mục' },
      { value: 'Lần', name: 'Lần' },
      { value: 'Yêu cầu', name: 'Yêu cầu' },
    ],
    // ---- ELECTRICITY PAYER ----
    electricityPayerOptions: (agencyRole) => [
      { value: '1', name: agencyRole === 'INVESTOR' ? 'NĐT nhượng quyền' : 'Chủ mặt bằng' },
      { value: '0', name: 'Nhà điều hành' },
    ],
    // ---- NOTIFICATION ----
    notificationStatusOptions: [
      { value: '1', name: 'Đã gửi' },
      { value: '0', name: 'Đã lên lịch' },
    ],
  },

  // MARK: ---- API ----
  API: {
    // MARK: ---- TRAM SAC ----
    // lay danh sach tram sac (trạm đổi pin) - API bss/stations
    requestGetChargeStationList: async (params) => {
      const url = 'bss/stations';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, data, pagination } = response;
        if (result === 'success' && Array.isArray(data)) {
          const chargeStations = data.map((item) => ({
            ...item,
            chargeOperator: item.operator,
            investor: item.agency,
            chargePoints: item.cabinets || [],
          }));
          const total = pagination?.total ?? data.length;
          return { chargeStations, total };
        }
        return { chargeStations: [], total: 0 };
      } catch (error) {
        return { chargeStations: [], total: 0 };
      }
    },
    // lay chi tiet tram sac (GET bss/stations/{id})
    getChargeStationDetail: async (chargeStationId) => {
      const url = `bss/stations/${chargeStationId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, data, station, chargeStation } = response;
        if (result === 'success') {
          const detail = data ?? station ?? chargeStation;
          return detail
            ? {
                ...detail,
                chargeOperator: detail.operator,
                chargePoints: detail.cabinets ?? detail.chargePoints,
              }
            : null;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // them tram sac (POST bss/stations)
    requestAddChargeStation: async (data) => {
      const url = 'bss/stations';
      try {
        const response = await axiosClient.post(url, data);
        const { result, station, reason } = response || {};
        if (result === 'success' && station) {
          return station;
        }
        return reason || 'Thêm trạm thất bại';
      } catch (error) {
        throw error?.response?.data?.reason || 'Thêm trạm sạc thất bại';
      }
    },
    // cap nhat tram sac (PUT bss/stations/{id})
    requestUpdateChargeStation: async (chargeStationId, data) => {
      const url = `bss/stations/${chargeStationId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response || {};
        return result === 'success';
      } catch (error) {
        throw error?.response?.data?.reason || 'Cập nhật trạm sạc thất bại';
      }
    },
    // xoa tram sac (DELETE bss/stations/{id})
    requestDeleteChargeStation: async (chargeStationId) => {
      const url = `bss/stations/${chargeStationId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response || {};
        return result === 'success';
      } catch (error) {
        throw error?.response?.data?.reason || 'Xóa trạm sạc thất bại';
      }
    },

    // MARK: ---- TRU SAC ----
    // lay danh sach tu pin (GET bss/cabinets)
    requestGetChargePointList: async (params) => {
      const url = 'bss/cabinets';
      try {
        const apiParams = {
          page: params?.page ?? 1,
          limit: params?.limit ?? AppConfigs.defaultPageLimit,
          stationId: params?.stationId ?? '',
          status: params?.status === ChargeConstants.ChargePointStatus.AVAILABLE ? 'READY' : params?.status || '',
          type: params?.type ?? '',
          search: params?.q ?? '',
          modelId: params?.modelId ?? '',
          mainDoorStatus: params?.mainDoorStatus ?? '',
          from: params?.from ?? '',
          to: params?.to ?? '',
        };
        const cleanParams = _.pickBy(apiParams, (value) => value !== null && value !== undefined && value !== '');
        const response = await axiosClient.get(url, { params: cleanParams });
        const { result, data, pagination } = response;
        if (result === 'success' && Array.isArray(data)) {
          const total = pagination?.total ?? data.length;
          const chargePoints = data.map((item) => ({
            ...item,
            pointId: item.cabinetId,
            pointCode: item.cabinetCode,
            chargeModel: item.cabinetModel,
            type: item.cabinetType ?? item.cabinetModel?.protocol,
            status: item.status === 'READY' ? ChargeConstants.ChargePointStatus.AVAILABLE : item.status,
            availableSlots: item.availableSlots,
            totalSlots: item.totalSlots,
            temperature: item.temperature,
            maxChargePower: item.maxChargePower,
            inputVoltage: item.inputVoltage,
            inputPhase: item.inputPhase,
            phone: item.phone,
            errorContent: item.errorContent ?? '',
          }));
          return { chargePoints, total };
        }
        return { chargePoints: [], total: 0 };
      } catch (error) {
        return { chargePoints: [], total: 0 };
      }
    },
    // lay chi tiet tru sac / tu pin (GET bss/cabinets/:id)
    // axiosClient interceptor tra ve response.data => body la { result, data }
    requestGetChargePointDetail: async (chargePointId) => {
      const url = `bss/cabinets/${chargePointId}`;
      try {
        const response = await axiosClient.get(url);
        const result = response?.result ?? response?.data?.result;
        const raw = response?.data ?? response?.cabinet ?? response?.data?.data;
        if (result === 'success' && raw) {
          const model = raw.chargeModel ?? raw.cabinetModel;
          const chargeModel = model
            ? {
                ...model,
                brandId: model.brandId ?? model.cabinetBrandId,
              }
            : undefined;
          return {
            ...raw,
            pointId: raw.cabinetId ?? raw.pointId,
            pointCode: raw.cabinetCode ?? raw.pointCode,
            cabinetName: raw.cabinetName ?? '',
            chargeStation: raw.station ?? raw.chargeStation,
            stationId: raw.stationId,
            chargeModel,
            serialNumber: raw.serialNumber ?? raw.cabinetCode,
            ocppId: raw.ocppId ?? raw.deviceId ?? raw.cabinetCode ?? raw.qrCode ?? '',
            operatorId: raw.operatorId ?? raw.station?.operatorId,
            networkOperator: raw.networkOperator ?? raw.simCarrier,
            phoneNumber: raw.phoneNumber ?? raw.phone,
            dataPackage: raw.dataPackage ?? raw.simPackage,
            dataPackageExpire: raw.dataPackageExpire ?? raw.simExpiry,
            protocol: raw.protocol ?? raw.chargeModel?.protocol ?? raw.cabinetModel?.protocol,
          };
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // them tru sac
    requestAddChargePoint: async (data) => {
      const url = '/cp/create';
      try {
        const response = await axiosClient.post(url, data);
        return response;
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm trụ sạc thất bại';
      }
    },
    // lay danh sach ngan pin cua tu (GET bss/cabinets/:id/slots)
    requestGetCabinetSlots: async (cabinetId) => {
      const url = `bss/cabinets/${cabinetId}/slots`;
      try {
        const response = await axiosClient.get(url);
        const result = response?.result ?? response?.data?.result;
        const raw = response?.data ?? response;
        const list = Array.isArray(raw) ? raw : raw?.slots;
        if (result === 'success' && Array.isArray(list)) {
          return list;
        }
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    },
    // cap nhat trang thai ngăn pin (PATCH bss/cabinets/:cabinetId/slots/:slotId)
    requestUpdateSlotStatus: async (cabinetId, slotId, status) => {
      const url = `bss/cabinets/${cabinetId}/slots/${slotId}`;
      try {
        const response = await axiosClient.patch(url, { status });
        const result = response?.result ?? response?.data?.result;
        if (result === 'success' || response === true) return true;
        return response?.data?.reason ?? response?.reason ?? false;
      } catch (error) {
        return error?.response?.data?.reason || error?.message || 'Cập nhật trạng thái ngăn pin thất bại';
      }
    },
    // lay chi tiet tu pin (GET bss/cabinets/:id)
    requestGetCabinetDetail: async (cabinetId) => {
      const url = `bss/cabinets/${cabinetId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, cabinet, data } = response;
        const raw = cabinet ?? data;
        if (result === 'success' && raw) {
          const model = raw.chargeModel ?? raw.cabinetModel;
          const chargeModel = model
            ? {
                ...model,
                brandId: model.brandId ?? model.cabinetBrandId,
              }
            : undefined;
          return {
            ...raw,
            pointId: raw.cabinetId ?? raw.pointId,
            pointCode: raw.cabinetCode ?? raw.pointCode,
            serialNumber: raw.serialNumber ?? raw.cabinetCode,
            ocppId: raw.ocppId ?? raw.deviceId ?? raw.cabinetCode ?? raw.qrCode ?? '',
            chargeModel,
            stationId: raw.stationId,
            networkOperator: raw.networkOperator ?? raw.simCarrier,
            phoneNumber: raw.phoneNumber ?? raw.phone,
            iccid: raw.iccid,
            dataPackage: raw.dataPackage ?? raw.simPackage,
            dataPackageExpire: raw.dataPackageExpire ?? raw.simExpiry,
            protocol: raw.protocol ?? raw.chargeModel?.protocol ?? raw.cabinetModel?.protocol,
          };
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // them tu pin (cabinet)
    requestAddCabinet: async (data) => {
      const url = '/bss/cabinets';
      try {
        const response = await axiosClient.post(url, data);
        return response;
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm tủ pin thất bại';
      }
    },
    // cap nhat tu pin (cabinet) - PUT bss/cabinets/:id
    requestUpdateCabinet: async (cabinetId, data) => {
      const url = `bss/cabinets/${cabinetId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result, reason } = response;
        if (result === 'success') return response;
        return reason || 'Cập nhật tủ pin thất bại';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật tủ pin thất bại';
      }
    },
    // bao loi tu pin - POST bss/cabinets/:cabinetId/report-error
    requestReportCabinetError: async (cabinetId, payload) => {
      const url = `bss/cabinets/${cabinetId}/report-error`;
      try {
        const response = await axiosClient.post(url, payload);
        const { result, reason } = response;
        if (result === 'success') return response;
        return reason || 'Báo lỗi tủ pin thất bại';
      } catch (error) {
        return error?.response?.data?.reason || 'Báo lỗi tủ pin thất bại';
      }
    },
    // tao lich bao tri dinh ky - POST bss/maintenance-schedules
    requestCreateMaintenanceSchedule: async (data) => {
      const url = 'bss/maintenance-schedules';
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        if (result === 'success') return response;
        return reason || 'Thiết lập lịch bảo trì định kỳ thất bại';
      } catch (error) {
        return error?.response?.data?.reason || 'Thiết lập lịch bảo trì định kỳ thất bại';
      }
    },
    // cap nhat tru sac
    requestUpdateChargePoint: async (chargePointId, data) => {
      const url = `/cp/${chargePointId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật trụ sạc thất bại';
      }
    },
    // xoa tru sac
    requestDeleteChargePoint: async (chargePointId) => {
      const url = `bss/cabinets/${chargePointId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa trụ sạc thất bại';
      }
    },
    // khoi dong lai tru sac
    requestRestartChargePoint: async (chargePointId) => {
      const url = '/cp/rebootCharger';
      try {
        const response = await axiosClient.post(url, { pointId: chargePointId });
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Khởi động lại trụ sạc thất bại';
      }
    },
    // "khoi dong lai" tu pin: PUT bss/cabinets/:id { status: "READY", reason: null }
    requestRestartCabinet: async (cabinetId) => {
      try {
        const response = await ChargeHelper.API.requestUpdateCabinet(cabinetId, {
          status: 'READY',
          reason: null,
        });
        // requestUpdateCabinet trả về response object khi success, hoặc string reason khi fail
        if (response && typeof response === 'object') {
          return response?.result === 'success';
        }
        return response || 'Khởi động lại tủ pin thất bại';
      } catch (error) {
        return error?.response?.data?.reason || 'Khởi động lại tủ pin thất bại';
      }
    },
    // thiet lap gioi han cong suat cua tru sac
    requestSetChargePointPowerLimit: async (chargePointId, powerLimit) => {
      const url = '/cp/setPowerLimit';
      try {
        const response = await axiosClient.post(url, { pointId: chargePointId, powerLimit });
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thiết lập công suất trụ sạc thất bại';
      }
    },

    // MARK: ---- VOI SAC ----
    // tao voi sac
    requestCreateChargeConnector: async (pointId, data) => {
      const url = `/cp/${pointId}/createConnector`;
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm vòi sạc thất bại';
      }
    },
    // xoa voi sac
    requestDeleteChargeConnector: async (pointId, connectorId) => {
      const url = `/cp/${pointId}/connector/${connectorId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa vòi sạc thất bại';
      }
    },
    // cap nhat thong tin voi sac
    requestUpdateChargeConnector: async (pointId, connectorId, data) => {
      const url = `/cp/${pointId}/connector/${connectorId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật vòi sạc thất bại';
      }
    },
    // dung voi sac
    requestStopChargeConnector: async (pointId, connectorNumber) => {
      const url = `/cp/stopCharger`;
      try {
        const response = await axiosClient.post(url, {
          pointId,
          connectorNumber,
        });
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Dừng vòi sạc thất bại';
      }
    },
    // kich hoat sac
    requestActivateCharger: async (params) => {
      const url = '/cp/activateChargerCashier';
      try {
        const response = await axiosClient.post(url, params);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Kích hoạt vòi sạc thất bại';
      }
    },

    // MARK: ---- THIET BI ----
    // lay danh sach thiet bi
    requestGetChargeInventoryList: async (params) => {
      const url = '/inventory/item/';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, items, total } = response;
        if (result === 'success') {
          return { items, total };
        }
        return { items: [], total: 0 };
      } catch (error) {
        return { items: [], total: 0 };
      }
    },
    // lay chi tiet thiet bi
    requestGetChargeInventoryDetail: async (categoryId) => {
      const url = `/inventory/item/${categoryId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, category } = response;
        if (result === 'success') {
          return category;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao thiet bi
    requestCreateChargeInventory: async (data) => {
      const url = '/inventory/item/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Tạo thiết bị thất bại';
      }
    },
    // cap nhat thiet bi
    requestUpdateChargeInventory: async (inventoryId, data) => {
      const url = `/inventory/item/${inventoryId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật thiết bị thất bại';
      }
    },
    // xoa thiet bi
    requestDeleteChargeInventory: async (inventoryId) => {
      const url = `/inventory/item/${inventoryId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa thiết bị thất bại';
      }
    },

    // MARK: ---- DANH MUC THIET BI ----
    // lay danh sach danh muc thiet bi
    requestGetChargeInventoryCategoryList: async (params) => {
      const url = '/inventory/category/';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, categories, total } = response;
        if (result === 'success') {
          return { categories, total };
        }
        return { categories: [], total: 0 };
      } catch (error) {
        return { categories: [], total: 0 };
      }
    },
    // lay chi tiet danh muc thiet bi
    requestGetChargeInventoryCategoryDetail: async (categoryId) => {
      const url = `/inventory/category/${categoryId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, category } = response;
        if (result === 'success') {
          return category;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao danh muc thiet bi
    requestCreateChargeInventoryCategory: async (data) => {
      const url = '/inventory/category/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Tạo danh mục thiết bị thất bại';
      }
    },
    // cap nhat danh muc thiet bi
    requestUpdateChargeInventoryCategory: async (categoryId, data) => {
      const url = `/inventory/category/${categoryId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật danh mục thiết bị thất bại';
      }
    },
    // xoa danh muc thiet bi
    requestDeleteChargeInventoryCategory: async (categoryId) => {
      const url = `/inventory/category/${categoryId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa danh mục thiết bị thất bại';
      }
    },

    // MARK: ---- DINH GIA ----
    // lay danh sach dinh gia
    requestGetChargePricingList: async (params) => {
      const url = '/pricing';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, pricings, total } = response;
        if (result === 'success') {
          return { pricings, total };
        }
        return { pricings: [], total: 0 };
      } catch (error) {
        return { pricings: [], total: 0 };
      }
    },
    // lay chi tiet dinh gia
    requestGetChargePricingDetail: async (pricingId) => {
      const url = `/pricing/${pricingId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, pricing } = response;
        if (result === 'success') {
          return pricing;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao dinh gia
    requestCreateChargePricing: async (data) => {
      const url = '/pricing/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response;
        return result === 'success' ? true : reason;
      } catch (error) {
        return error?.response?.data?.reason || 'Tạo định giá thất bại';
      }
    },
    // cap nhat dinh gia
    requestUpdateChargePricing: async (pricingId, data) => {
      const url = `/pricing/${pricingId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật định giá thất bại';
      }
    },
    // xoa dinh gia
    requestDeleteChargePricing: async (pricingId) => {
      const url = `/pricing/${pricingId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa định giá thất bại';
      }
    },

    // MARK: ---- THONG BAO ----
    // lay danh sach thong bao
    getMessageLogList: async (chargeStationId, params) => {
      // const url = '/message';
      // const requestParams = { ...params };
      // if (chargeStationId) {
      //   requestParams.stationId = chargeStationId;
      // }
      // try {
      //   const response = await axiosClient.get(url, {
      //     params: requestParams,
      //   });
      //   const { result, messages, total } = response;
      //   if (result === 'success') {
      //     return { messages, total };
      //   }
      //   return null;
      // } catch (error) {
      //   return error?.response?.data?.reason || null;
      // }
    },

    // MARK: ---- DANH SACH PIN ----
    // lay danh sach pin
    requestGetBatteryList: async (params = {}) => {
      const url = 'bss/batteries';
      try {
        const cleanParams = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
        const response = await axiosClient.get(url, { params: cleanParams });
        const { result, data, pagination } = response;
        if (result === 'success' && Array.isArray(data)) {
          return { batteries: data, total: pagination?.total || 0 };
        }
        return { batteries: [], total: 0 };
      } catch (error) {
        console.error('requestGetBatteryList error:', error);
        return { batteries: [], total: 0 };
      }
    },

    // them pin moi
    requestCreateBattery: async (data) => {
      const url = 'bss/batteries';
      try {
        const response = await axiosClient.post(url, data);
        const { result, reason } = response || {};
        if (result === 'success') return true;
        return reason || 'Thêm pin thất bại';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm pin thất bại';
      }
    },

    // MARK: ---- HANG SAN XUAT PIN ----
    // lấy danh sách hãng sản xuất pin
    requestGetChargeBrandList: async (params = {}) => {
      const url = '/battery-brand';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, brands, total } = response;
        if (result === 'success') {
          return { brands, total };
        }
        return { brands: [], total: 0 };
      } catch (error) {
        return { brands: [], total: 0 };
      }
    },
    // lay chi tiet hang san xuat pin
    requestGetChargeBrandDetail: async (brandId) => {
      const url = `/battery-brand/${brandId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, brand } = response;
        if (result === 'success') {
          return brand;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // lay danh sach hang san xuat tu pin
    requestGetCabinetBrandList: async (params = {}) => {
      const url = '/cabinet-brand';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, brands, total } = response;
        if (result === 'success') {
          return { brands, total };
        }
        return { brands: [], total: 0 };
      } catch (error) {
        return { brands: [], total: 0 };
      }
    },
    // lay chi tiet hang san xuat tu pin
    requestGetCabinetBrandDetail: async (brandId) => {
      const url = `/cabinet-brand/${brandId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, brand } = response;
        if (result === 'success') {
          return brand;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // them hang san xuat tu pin
    requestAddCabinetBrand: async (data) => {
      const url = '/cabinet-brand/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm hãng sản xuất tủ pin thất bại';
      }
    },
    // cap nhat hang san xuat tu pin
    requestUpdateCabinetBrand: async (brandId, data) => {
      const url = `/cabinet-brand/${brandId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật hãng sản xuất tủ pin thất bại';
      }
    },
    // xoa hang san xuat tu pin
    requestDeleteCabinetBrand: async (brandId) => {
      const url = `/cabinet-brand/${brandId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa hãng sản xuất tủ pin thất bại';
      }
    },
    // lay danh sach model tu pin
    requestGetCabinetBrandModelList: async (brandId, params = {}) => {
      const url = `/cabinet-brand/${brandId}/model`;
      try {
        const response = await axiosClient.get(url, { params });
        const { result, models, total } = response;
        if (result === 'success') {
          return { models, total };
        }
        return { models: [], total: 0 };
      } catch (error) {
        return { models: [], total: 0 };
      }
    },
    // them model tu pin
    requestAddCabinetBrandModel: async (brandId, data) => {
      const url = `/cabinet-brand/${brandId}/model/create`;
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm model tủ pin thất bại';
      }
    },
    // cap nhat model tu pin
    requestUpdateCabinetBrandModel: async (brandId, modelId, data) => {
      const url = `/cabinet-brand/${brandId}/model/${modelId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật model tủ pin thất bại';
      }
    },
    // xoa model tu pin
    requestDeleteCabinetBrandModel: async (brandId, modelId) => {
      const url = `/cabinet-brand/${brandId}/model/${modelId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa model tủ pin thất bại';
      }
    },
    // xoa hang san xuat pin
    requestDeleteChargeBrand: async (brandId) => {
      const url = `/battery-brand/${brandId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa hãng sản xuất pin thất bại';
      }
    },
    // them hang san xuat pin
    requestAddChargeBrand: async (data) => {
      const url = '/battery-brand/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm hãng sản xuất pin thất bại';
      }
    },
    // cap nhat hang san xuat pin
    requestUpdateChargeBrand: async (brandId, data) => {
      const url = `/battery-brand/${brandId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật hãng sản xuất pin thất bại';
      }
    },
    // lay danh sach model pin
    requestGetBatteryBrandModelList: async (brandId, params = {}) => {
      const url = `/battery-brand/${brandId}/model`;
      try {
        const response = await axiosClient.get(url, { params });
        const { result, models, total } = response;
        if (result === 'success') {
          return { models, total };
        }
        return { models: [], total: 0 };
      } catch (error) {
        return { models: [], total: 0 };
      }
    },
    // them model pin
    requestAddBatteryBrandModel: async (brandId, data) => {
      const url = `/battery-brand/${brandId}/model/create`;
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm model pin thất bại';
      }
    },
    // them model pin tu spec
    requestAddBatteryBrandModelFromSpec: async (brandId, data) => {
      const url = `bss/battery-brands/${brandId}/models/from-spec`;
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm model pin thất bại';
      }
    },
    // cap nhat model pin
    requestUpdateBatteryBrandModel: async (brandId, modelId, data) => {
      const url = `/battery-brand/${brandId}/model/${modelId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật model pin thất bại';
      }
    },
    // xoa model pin
    requestDeleteBatteryBrandModel: async (brandId, modelId) => {
      const url = `/battery-brand/${brandId}/model/${modelId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa model pin thất bại';
      }
    },
    // lay danh sach chuẩn hỗ trợ pin
    requestGetBatterySpecs: async () => {
      const url = '/battery-specs';
      try {
        const response = await axiosClient.get(url);
        const { result, data } = response;
        if (result === 'success' && Array.isArray(data)) {
          return data;
        }
        return [];
      } catch (error) {
        return [];
      }
    },

    // MARK: ---- MODEL TRU SAC ----
    // lay danh sach model tru sac
    requestGetChargeModelList: async (params) => {
      const url = `/charger/model`;
      try {
        const response = await axiosClient.get(url, { params });
        const { result, models, total } = response;
        if (result === 'success') {
          return { models, total };
        }
        return { models: [], total: 0 };
      } catch (error) {
        return { models: [], total: 0 };
      }
    },
    // xoa model tru sac
    requestDeleteChargeModel: async (modelId) => {
      const url = `/charger/model/${modelId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa model trụ sạc thất bại';
      }
    },
    // them model tru sac
    requestAddChargeModel: async (data) => {
      const url = '/charger/model/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm model trụ sạc thất bại';
      }
    },
    // cap nhat model tru sac
    requestUpdateChargeModel: async (modelId, data) => {
      const url = `/charger/model/${modelId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật model trụ sạc thất bại';
      }
    }, // them model tru sac
    requestAddChargeModel: async (data) => {
      const url = '/charger/model/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm model trụ sạc thất bại';
      }
    },
    // cap nhat model tru sac
    requestUpdateChargeModel: async (modelId, data) => {
      const url = `/charger/model/${modelId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật model trụ sạc thất bại';
      }
    },

    // MARK: ---- TAI KHOAN DIEN LUC ----
    // them tai khoan dien luc
    requestAddEnergyAccount: async (data) => {
      const url = '/energyAccount/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm tài khoản điện lực thất bại';
      }
    },
    // cap nhat tai khoan dien luc
    requestUpdateEnergyAccount: async (accountId, data) => {
      const url = `/energyAccount/${accountId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật tài khoản điện lực thất bại';
      }
    },
    // xoa tai khoan dien luc
    requestDeleteEnergyAccount: async (accountId) => {
      const url = `/energyAccount/${accountId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa tài khoản điện lực thất bại';
      }
    },

    // MARK: ---- PAYMENT ----
    Payment: {
      // lay danh sach thanh toan
      requestGetPaymentList: async (params) => {
        const url = '/payment';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, payments, total } = response;
          if (result === 'success') {
            return { payments, total };
          }
          return { payments: [], total: 0 };
        } catch (error) {
          return { payments: [], total: 0 };
        }
      },
    },

    // MARK: ---- WALLET TRANSACTION ----
    WalletTransaction: {
      // lay danh sach giao dich vi
      requestGetWalletTransactionList: async (params) => {
        const url = '/wallet/transactions';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, walletTransactions, total } = response;
          if (result === 'success') {
            return { walletTransactions, total };
          }
          return { walletTransactions: [], total: 0 };
        } catch (error) {
          return { walletTransactions: [], total: 0 };
        }
      },
    },

    // MARK: ---- HANG XE ----
    VehicleBrand: {
      // lay danh sach hang xe
      requestGetVehicleBrandList: async (params = {}) => {
        const url = '/brand';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, brands, total } = response;
          if (result === 'success') {
            return { brands, total };
          }
          return { brands: [], total: 0 };
        } catch (error) {
          return { brands: [], total: 0 };
        }
      },
    },

    // MARK: ---- DONG XE ----
    VehicleModel: {
      // lay danh sach dong xe
      requestGetVehicleModelList: async (brandId, params = {}) => {
        const url = `/brand/${brandId}/model`;
        try {
          const response = await axiosClient.get(url, { params });
          const { result, models, total } = response;
          if (result === 'success') {
            return { models, total };
          }
          return { models: [], total: 0 };
        } catch (error) {
          return { models: [], total: 0 };
        }
      },
    },

    // MARK: ---- PHIEN SAC ----
    ChargeTransaction: {
      // lay danh sach phien sac
      requestGetChargeTransactionList: async (params) => {
        const url = '/ct';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, chargeTransactions, total } = response;
          if (result === 'success') {
            return { chargeTransactions, total };
          }
          return { chargeTransactions: [], total: 0 };
        } catch (error) {
          return { chargeTransactions: [], total: 0 };
        }
      },
    },

    // MARK: ---- HANG XE ----
    ChargeVehicleBrand: {
      // lay danh sach hang xe
      requestGetChargeVehicleBrandList: async (params = {}) => {
        const url = '/brand';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, brands, total } = response;
          if (result === 'success') {
            return { brands, total };
          }
          return { brands: [], total: 0 };
        } catch (error) {
          return { brands: [], total: 0 };
        }
      },
      // them hang xe
      requestAddChargeVehicleBrand: async (data) => {
        const url = '/brand/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm hãng xe thất bại';
        }
      },
      // cap nhat hang xe
      requestUpdateChargeVehicleBrand: async (brandId, data) => {
        const url = `/brand/${brandId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật hãng xe thất bại';
        }
      },
      // xoa hang xe
      requestDeleteChargeVehicleBrand: async (brandId) => {
        const url = `/brand/${brandId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa hãng xe thất bại';
        }
      },
    },

    // MARK: ---- DONG XE ----
    ChargeVehicleModel: {
      // lay danh sach dong xe
      requestGetChargeVehicleModelList: async (vehicleBrandId, params = {}) => {
        const url = `/brand/${vehicleBrandId}/model`;
        try {
          const response = await axiosClient.get(url, { params });
          const { result, models, total } = response;
          if (result === 'success') {
            return { models, total };
          }
          return { models: [], total: 0 };
        } catch (error) {
          return { models: [], total: 0 };
        }
      },
      // Lấy dòng xe của nhà điều hành ( Để hiển thị ở màn gói thuê xe  )
      requestGetOperatorVehicleModelList: async (operatorIdOrParams, maybeParams = {}) => {
        const url = `brand/model/operator`;
        const params =
          operatorIdOrParams != null &&
          typeof operatorIdOrParams === 'object' &&
          !Array.isArray(operatorIdOrParams)
            ? { ...operatorIdOrParams, ...maybeParams }
            : {
                ...maybeParams,
                ...(operatorIdOrParams != null && typeof operatorIdOrParams !== 'object'
                  ? { operatorId: operatorIdOrParams }
                  : {}),
              };
        try {
          const response = await axiosClient.get(url, { params });
          const { result, models, total } = response;
          if (result === 'success') {
            return { models, total };
          }
          return { models: [], total: 0 };
        } catch (error) {
          return { models: [], total: 0 };
        }
      },
      // them dong xe
      requestAddChargeVehicleModel: async (vehicleBrandId, data) => {
        const url = `/brand/${vehicleBrandId}/model/create`;
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm model xe thất bại';
        }
      },
      // cap nhat dong xe
      requestUpdateChargeVehicleModel: async (vehicleBrandId, vehicleModelId, data) => {
        const url = `/brand/${vehicleBrandId}/model/${vehicleModelId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật model xe thất bại';
        }
      },
      // xoa dong xe
      requestDeleteChargeVehicleModel: async (vehicleBrandId, vehicleModelId) => {
        const url = `/brand/${vehicleBrandId}/model/${vehicleModelId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa model xe thất bại';
        }
      },
    },

    // MARK: ---- XE ----
    Vehicle: {
      // lay danh sach xe
      requestGetVehicleList: async (params = {}) => {
        const url = '/vehicle';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, vehicles, total } = response;
          if (result === 'success') {
            return { vehicles, total };
          }
          return { vehicles: [], total: 0 };
        } catch (error) {
          return { vehicles: [], total: 0 };
        }
      },
      // lay chi tiet xe
      requestGetVehicleDetail: async (vehicleId) => {
        const url = `/vehicle/${vehicleId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, vehicle } = response;
          if (result === 'success') {
            return vehicle;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      // them xe
      requestAddVehicle: async (data) => {
        const url = '/vehicle/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm xe thất bại';
        }
      },
      // them xe nha dieu hanh
      requestAddOperatorVehicle: async (data) => {
        const url = '/operator-vehicle/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          throw error?.response?.data?.reason || 'Thêm xe thất bại';
        }
      },
      // cap nhat xe
      requestUpdateVehicle: async (vehicleId, data) => {
        const url = `/vehicle/${vehicleId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật xe thất bại';
        }
      },
      // xoa xe
      requestDeleteVehicle: async (vehicleId) => {
        const url = `/vehicle/${vehicleId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa xe thất bại';
        }
      },
    },
    // MARK: ---- SYSTEM LOG ----
    SystemLog: {
      // lay danh sach thong bao he thong
      requestGetSystemLogList: async (params) => {
        // const url = '/message';
        // try {
        //   const response = await axiosClient.get(url, { params });
        //   const { result, messages, total } = response;
        //   if (result === 'success') {
        //     return { messages, total };
        //   }
        //   return { messages: [], total: 0 };
        // } catch (error) {
        //   return { messages: [], total: 0 };
        // }
      },
    },
    // MARK: ---- DRIVER ----
    Driver: {
      // lay danh sach khach hang
      requestGetDriverList: async (params = {}) => {
        const url = '/driver';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, drivers, total } = response;
          if (result === 'success') {
            return { drivers, total };
          }
          return { drivers: [], total: 0 };
        } catch (error) {
          return { drivers: [], total: 0 };
        }
      },
      // lay chi tiet khach hang
      requestGetDriverDetail: async (driverId) => {
        const url = `/driver/${driverId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, driver } = response;
          if (result === 'success') {
            return driver;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      // them khach hang
      requestAddDriver: async (data) => {
        const url = '/driver/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result, reason, driver, driverId } = response;
          if (result === 'success') {
            return driver || driverId || true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm mới khách hàng thất bại';
        }
      },
      requestCreateDriverBankAccount: async (data) => {
        const url = '/driver/bankAccount/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result, reason, bankAccount } = response;
          if (result === 'success') {
            return bankAccount || true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Tạo tài khoản ngân hàng khách hàng thất bại';
        }
      },
      requestGetDriverBankAccountList: async (driverId) => {
        const url = `/driver/bankAccount/all?driverId=${driverId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, bankAccounts } = response;
          if (result === 'success') {
            return bankAccounts ?? [];
          }
          return [];
        } catch (error) {
          return [];
        }
      },
      requestUpdateDriverBankAccount: async (bankAccountId, data) => {
        const url = `/driver/bankAccount/${bankAccountId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật tài khoản ngân hàng khách hàng thất bại';
        }
      },
      // cap nhat khach hang
      requestUpdateDriver: async (driverId, data) => {
        const url = `/driver/${driverId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Chỉnh sửa thông tin khách hàng thất bại';
        }
      },
      // xoa khach hang
      requestDeleteDriver: async (driverId) => {
        const url = `/driver/${driverId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result, reason } = response;
          if (result === 'success') {
            return true;
          }
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa khách hàng thất bại';
        }
      },
      // nap tien cho khach hang
      requestTopUpDriver: async (driverId, amount) => {
        const url = '/driver/topup';
        try {
          const response = await axiosClient.post(url, {
            driverId,
            amount,
            paymentMethod: ChargeConstants.ChargePaymentMethod.INTERNAL,
          });
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Nạp tiền thất bại';
        }
      },
      // lay lich su giao dich cua khach hang
      requestGetDriverTransactionHistory: async (driverId, params = {}) => {
        const url = `/driver/${driverId}/transactions`;
        try {
          const response = await axiosClient.get(url, { params });
          const { result, paymentCount, topupCount, payments, topups, transactions } = response;
          if (result === 'success') {
            return { paymentCount, topupCount, payments, topups, transactions };
          }
          return { paymentCount: 0, topupCount: 0, payments: [], topups: [], transactions: [] };
        } catch (error) {
          return { paymentCount: 0, topupCount: 0, payments: [], topups: [], transactions: [] };
        }
      },
      // lay lich su sac xe cua khach hang
      requestGetDriverChargeSessions: async (driverId, params = {}) => {
        const url = `/driver/${driverId}/chargeSessions`;
        try {
          const response = await axiosClient.get(url, { params });
          const { result, chargeSessions, total } = response;
          if (result === 'success') {
            return { chargeSessions, total };
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || 'Lấy lịch sử sạc xe thất bại';
        }
      },
    },

    // MARK: ---- RFID ----
    RFID: {
      // lay danh sach the RFID
      requestGetRFIDCardList: async (params = {}) => {
        const url = '/rfid';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, chargeRFIDs, total } = response;
          if (result === 'success') {
            return { chargeRFIDs, total };
          }
          return { chargeRFIDs: [], total: 0 };
        } catch (error) {
          return { chargeRFIDs: [], total: 0 };
        }
      },
      // lay chi tiet the RFID
      requestGetRFIDCardDetail: async (rfidCardId) => {
        const url = `/rfid/${rfidCardId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, chargeRFID } = response;
          if (result === 'success') {
            return chargeRFID;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      // them the RFID
      requestAddRFIDCard: async (data) => {
        const url = '/rfid/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result, reason } = response;
          if (result === 'success') return true;
          return reason;
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm thẻ RFID thất bại';
        }
      },
      // cap nhat the RFID
      requestUpdateRFIDCard: async (rfidCardId, data) => {
        const url = `/rfid/${rfidCardId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật thẻ RFID thất bại';
        }
      },
      // xoa the RFID
      requestDeleteRFIDCard: async (rfidCardId) => {
        const url = `/rfid/${rfidCardId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa thẻ RFID thất bại';
        }
      },
    },

    // ---- DASHBOARD ----
    Dashboard: {
      requestGetDailyData: async (params) => {
        const url = '/dashboard/daily';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, daily } = response;
          if (result === 'success') {
            return daily;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetRealtimeData: async (params) => {
        const url = '/dashboard/realtime';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, realtime } = response;
          if (result === 'success') {
            return realtime;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetStationStatistics: async (params) => {
        const url = '/dashboard/stationStatistics';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetPointStatistics: async (params) => {
        const url = '/dashboard/pointStatistics';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetPointSummary: async (params) => {
        const url = '/dashboard/pointSummary';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, statuses } = response;
          if (result === 'success') {
            return {
              [ChargeConstants.ChargePointStatus.AVAILABLE]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.AVAILABLE
                )?.total || 0,
              [ChargeConstants.ChargePointStatus.BUSY]:
                _.find(statuses, (item) => item.status === ChargeConstants.ChargePointStatus.BUSY)
                  ?.total || 0,
              [ChargeConstants.ChargePointStatus.FAULT]:
                _.find(statuses, (item) => item.status === ChargeConstants.ChargePointStatus.FAULT)
                  ?.total || 0,
              [ChargeConstants.ChargePointStatus.MAINTAINING]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.MAINTAINING
                )?.total || 0,
              [ChargeConstants.ChargePointStatus.DISCONNECTED]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.DISCONNECTED
                )?.total || 0,
              [ChargeConstants.ChargePointStatus.DISABLED]:
                _.find(
                  statuses,
                  (item) => item.status === ChargeConstants.ChargePointStatus.DISABLED
                )?.total || 0,
            };
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetAgencyStatistics: async (params) => {
        const url = '/dashboard/agencyStatistics';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, agencies } = response;
          if (result === 'success') {
            return {
              [AgencyConstants.AgencyRole.GROUP]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.GROUP)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.SALE]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.SALE)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.INVESTOR]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.INVESTOR)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.LANDLORD]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.LANDLORD)
                  ?.count || 0,
              [AgencyConstants.AgencyRole.CHARGEPOINT]:
                _.find(agencies, (item) => item.primaryRole === AgencyConstants.AgencyRole.CHARGEPOINT)
                  ?.count || 0,
            };
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetRevenueSummary: async (params) => {
        const url = '/dashboard/revenueSummary';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetMonthlyGroupCommission: async (params) => {
        const url = '/dashboard/getMonthlyGroupCommission';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, investments } = response;
          if (result === 'success') {
            return investments;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetMonthlyLandlordCommission: async (params) => {
        const url = '/dashboard/getMonthlyLandlordCommission';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetLandlordSummary: async (params) => {
        const url = '/dashboard/landlordSummary';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetMonthlyInvestorCommission: async (params) => {
        const url = '/dashboard/getMonthlyInvestorCommission';
        try {
          const response = await axiosClient.get(url, { params });
          const { result } = response;
          if (result === 'success') {
            return response;
          }
          return null;
        } catch (error) {
          return null;
        }
      },

      requestGetMonthlyStationEnergy: async (params) => {
        const url = '/dashboard/getMonthlyStationEnergy';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, monthlyEnergy } = response;
          if (result === 'success') {
            return monthlyEnergy;
          }
          return null;
        } catch (error) {
          return null;
        }
      },
    },

    // MARK: ---- TUTORIAL ----
    Tutorial: {
      requestGetTutorialList: async (params) => {
        const url = '/tutorial';
        try {
          const response = await axiosClient.get(url, {
            params,
            baseURL: `${AppConfigs.env.baseUrl}api/v1`,
          });
          const { result, tutorials, total } = response;
          if (result === 'success') {
            return { tutorials, total };
          }
          return { tutorials: [], total: 0 };
        } catch (error) {
          return { tutorials: [], total: 0 };
        }
      },
      requestCreateTutorial: async (params) => {
        const url = '/tutorial';
        try {
          const response = await axiosClient.post(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`,
          });
          const { result, tutorial, reason } = response;
          if (result === 'success') {
            return tutorial;
          }
          return reason;
        } catch (error) {
          throw error?.response?.data?.reason || 'Thêm hướng dẫn sử dụng thất bại';
        }
      },
      requestUpdateTutorial: async (tutorialId, params) => {
        const url = `/tutorial/${tutorialId}`;
        try {
          const response = await axiosClient.put(url, params, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`,
          });
          const { result } = response;
          return result === 'success';
        } catch (error) {
          throw error?.response?.data?.reason || 'Cập nhật hướng dẫn sử dụng thất bại';
        }
      },
      requestDeleteTutorial: async (tutorialId) => {
        const url = `/tutorial/${tutorialId}`;
        try {
          const response = await axiosClient.delete(url, {
            baseURL: `${AppConfigs.env.baseUrl}api/v1`,
          });
          const { result } = response;
          return result === 'success';
        } catch (error) {
          throw error?.response?.data?.reason || 'Xoá hướng dẫn sử dụng thất bại';
        }
      },
    },

    // MARK: ---- NOTIFICATION ----
    Notification: {
      // lay danh sach thong bao
      requestGetNotificationList: async (params) => {
        const url = '/notification';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, notifications, total } = response;
          if (result === 'success') {
            return { notifications, total };
          }
          return { notifications: [], total: 0 };
        } catch (error) {
          return { notifications: [], total: 0 };
        }
      },
      // lay chi tiet thong bao
      requestGetNotificationDetail: async (notificationId) => {
        const url = `/notification/${notificationId}`;
        try {
          const response = await axiosClient.get(url);
          const { result, notification } = response;
          if (result === 'success') {
            return notification;
          }
          return null;
        } catch (error) {
          return error?.response?.data?.reason || null;
        }
      },
      // them thong bao
      requestAddNotification: async (data) => {
        const url = '/notification/create';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Thêm thông báo thất bại';
        }
      },
      // cap nhat thong bao
      requestUpdateNotification: async (notificationId, data) => {
        const url = `/notification/${notificationId}`;
        try {
          const response = await axiosClient.put(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Cập nhật thông báo thất bại';
        }
      },
      // xoa thong bao
      requestDeleteNotification: async (notificationId) => {
        const url = `/notification/${notificationId}`;
        try {
          const response = await axiosClient.delete(url);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Xóa thông báo thất bại';
        }
      },
      // thong ke thong bao
      requestGetNotificationSummary: async (params) => {
        const url = '/notification/notificationSummary';
        try {
          const response = await axiosClient.get(url, { params });
          const { result, categories } = response;
          if (result === 'success') {
            return {
              [ChargeConstants.NotificationCategory.BUSINESS]:
                _.find(categories, (item) => item.category === ChargeConstants.NotificationCategory.BUSINESS
                )?.total || 0,
              [ChargeConstants.NotificationCategory.OPERATION]:
                _.find(categories, (item) => item.category === ChargeConstants.NotificationCategory.OPERATION)
                  ?.total || 0,
              [ChargeConstants.NotificationCategory.PROMOTION]:
                _.find(categories, (item) => item.category === ChargeConstants.NotificationCategory.PROMOTION)
                  ?.total || 0,
              [ChargeConstants.NotificationCategory.OTHER]:
                _.find(categories, (item) => item.category === ChargeConstants.NotificationCategory.OTHER
                )?.total || 0,
            };
          }
          return null;
        } catch (error) {
          return { categories: [] };
        }
      },
      // doc tat ca thong bao
      requestReadAllNotification: async (data) => {
        const url = '/notification/readAll';
        try {
          const response = await axiosClient.post(url, data);
          const { result } = response;
          return result === 'success';
        } catch (error) {
          return error?.response?.data?.reason || 'Đọc tất cả thông báo thất bại';
        }
      },
    },
  },

  // MARK: ---- UTILS ----
  Utils: {
    // ---- USER ----
    // lay ten role cua user
    getUserRoleName: (role) => {
      switch (role) {
        case ChargeConstants.UserRole.ADMIN:
          return 'Quản trị viên';
        case ChargeConstants.UserRole.OPERATOR:
          return 'Nhà điều hành';
        case ChargeConstants.UserRole.AGENCY:
          return 'Đối tác';
        case ChargeConstants.UserRole.DRIVER:
          return 'Khách hàng';
        case ChargeConstants.UserRole.MAINTAINER:
          return 'Kỹ thuật viên';
        default:
          return '';
      }
    },
    // ---- RFID ----
    // lay ten trang thai the RFID
    getRFIDCardStatusName: (status) => {
      switch (status) {
        case ChargeConstants.RFIDCardStatus.NORMAL:
          return 'Đang hoạt động';
        case ChargeConstants.RFIDCardStatus.BLOCKED:
          return 'Bị khóa';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai the RFID
    getRFIDCardStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.RFIDCardStatus.NORMAL:
          return 'success';
        case ChargeConstants.RFIDCardStatus.BLOCKED:
          return 'danger';
        default:
          return '';
      }
    },
    // ---- WALLET TRANSACTIONS ----
    // lay ten trang thai giao dich vi
    getWalletTransactionStatusName: (status) => {
      switch (status) {
        case ChargeConstants.WalletTransactionStatus.QUEUED:
          return 'Đang xử lý';
        case ChargeConstants.WalletTransactionStatus.PENDING:
          return 'Chờ thanh toán';
        case ChargeConstants.WalletTransactionStatus.COMPLETED:
          return 'Hoàn thành';
        case ChargeConstants.WalletTransactionStatus.CANCELLED:
          return 'Đã hủy';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai giao dich vi
    getWalletTransactionStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.WalletTransactionStatus.QUEUED:
          return 'primary';
        case ChargeConstants.WalletTransactionStatus.PENDING:
          return 'warning';
        case ChargeConstants.WalletTransactionStatus.COMPLETED:
          return 'success';
        case ChargeConstants.WalletTransactionStatus.CANCELLED:
          return 'danger';
        default:
          return '';
      }
    },
    // ---- PAYMENT ----
    // lay ten trang thai thanh toan
    getPaymentStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargePaymentStatus.PENDING:
          return 'Chờ xác nhận';
        case ChargeConstants.ChargePaymentStatus.COMPLETED:
          return 'Đã thanh toán';
        case ChargeConstants.ChargePaymentStatus.FAILED:
          return 'Thất bại';
        case ChargeConstants.ChargePaymentStatus.CANCELLED:
          return 'Đã hủy';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai thanh toan
    getPaymentStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargePaymentStatus.PENDING:
          return 'warning';
        case ChargeConstants.ChargePaymentStatus.COMPLETED:
          return 'success';
        case ChargeConstants.ChargePaymentStatus.FAILED:
          return 'danger';
        case ChargeConstants.ChargePaymentStatus.CANCELLED:
          return 'danger';
        default:
          return '';
      }
    },
    // ---- KHACH HANG ----
    // lay ten trang thai khach hang
    getDriverStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeDriverStatus.REGISTERED:
          return 'Chờ kích hoạt';
        case ChargeConstants.ChargeDriverStatus.NORMAL:
          return 'Đang hoạt động';
        case ChargeConstants.ChargeDriverStatus.SUSPENDED:
          return 'Ngừng hoạt động';
        case ChargeConstants.ChargeDriverStatus.DELETED:
          return 'Đã xóa';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai khach hang
    getDriverStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeDriverStatus.REGISTERED:
          return 'primary';
        case ChargeConstants.ChargeDriverStatus.NORMAL:
          return 'success';
        case ChargeConstants.ChargeDriverStatus.SUSPENDED:
          return 'secondary';
        case ChargeConstants.ChargeDriverStatus.DELETED:
          return 'danger';
        default:
          return '';
      }
    },

    // lay ten loai gia sac
    getChargePricingTypeName: (price) => {
      switch (price) {
        case 0:
          return 'Tiêu chuẩn';
        case 1:
          return 'Miễn phí';
        default:
          return `Ưu đãi ${price * 100}%`;
      }
    },
    // lay mau sac cua loai gia sac
    getChargePricingTypeColor: (price) => {
      switch (price) {
        case 0:
          return 'success';
        case 1:
          return 'secondary';
        default:
          return 'primary';
      }
    },

    // lay ten loai giao dich
    getDriverTransactionName: (fundingSource) => {
      switch (fundingSource) {
        case 'INTERNAL':
        case 'CASH':
        case 'VNPAY':
        case 'MOMO':
          return 'Nạp tiền';
        case 'WALLET':
          return 'Chi tiền';
        case 'REFUND':
          return 'Hoàn tiền';
        default:
          return '';
      }
    },
    // ---- XE ----
    // lay ten trang thai xe
    getVehicleStatusName: (status) => {
      switch (status) {
        case ChargeConstants.VehicleStatus.NORMAL:
          return 'Đang hoạt động';
        case ChargeConstants.VehicleStatus.DELETED:
          return 'Đã xóa';
        case ChargeConstants.VehicleStatus.PENDING:
          return 'Chờ xác nhận';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai xe
    getVehicleStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.VehicleStatus.NORMAL:
          return 'success';
        case ChargeConstants.VehicleStatus.DELETED:
          return 'danger';
        case ChargeConstants.VehicleStatus.PENDING:
          return 'warning';
        default:
          return '';
      }
    },

    // ---- PHIEN SAC ----
    // lay ten trang thai phien sac
    getChargeTransactionStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeTransactionStatus.INITIATING:
          return 'Khởi tạo';
        case ChargeConstants.ChargeTransactionStatus.PREPARING:
          return 'Chuẩn bị';
        case ChargeConstants.ChargeTransactionStatus.CHARGING:
          return 'Đang sạc';
        case ChargeConstants.ChargeTransactionStatus.FINISHING:
          return 'Đang kết thúc';
        case ChargeConstants.ChargeTransactionStatus.FINISHED:
          return 'Đã kết thúc';
        case ChargeConstants.ChargeTransactionStatus.CANCELLED:
          return 'Đã hủy';
        case ChargeConstants.ChargeTransactionStatus.FAILED:
          return 'Lỗi';
        default:
          return '';
      }
    },
  // Lấy màu trạng thái phiên đổi pin / phiên sạc
    getChargeTransactionStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeTransactionStatus.CHARGING:
          return 'warning';
        case ChargeConstants.SwapSessionStatus.FINISHED:
          return 'disabled';
        case ChargeConstants.SwapSessionStatus.BATTERY_RETURNED:
          return 'primary';
        case ChargeConstants.SwapSessionStatus.BATTERY_PICKED_UP:
          return 'warning';
        case ChargeConstants.SwapSessionStatus.INITIATING:
          return 'success';
        case ChargeConstants.SwapSessionStatus.WAITING_PICK_UP:
          return 'secondary';
        case ChargeConstants.SwapSessionStatus.WAITING_RETURN:
          return 'danger';
        case ChargeConstants.SwapSessionStatus.PICK_UP_EXPIRED:
          return 'danger';
        case ChargeConstants.SwapSessionStatus.FAILED:
          return 'danger';
        case ChargeConstants.SwapSessionStatus.CANCELLED:
          return 'danger';
        default:
          return '';
      }
    },
    // ---- PHIEN DOI PIN ----
    getSwapSessionStatusName: (status) => {
      switch (status) {
        case ChargeConstants.SwapSessionStatus.FINISHED:
          return 'Đã kết thúc';
        case ChargeConstants.SwapSessionStatus.BATTERY_RETURNED:
          return 'Đã trả pin';
        case ChargeConstants.SwapSessionStatus.BATTERY_PICKED_UP:
          return 'Đã lấy pin';
        case ChargeConstants.SwapSessionStatus.INITIATING:
          return 'Đang khởi tạo';
        case ChargeConstants.SwapSessionStatus.WAITING_PICK_UP:
          return 'Chờ lấy pin';
        case ChargeConstants.SwapSessionStatus.WAITING_RETURN:
          return 'Chờ trả pin';
        case ChargeConstants.SwapSessionStatus.PICK_UP_EXPIRED:
          return 'Hết thời gian lấy pin';
        case ChargeConstants.SwapSessionStatus.FAILED:
          return 'Lỗi';
        case ChargeConstants.SwapSessionStatus.CANCELLED:
          return 'Đã hủy';
        default:
          return '';
      }
    },
    getSwapSessionStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.SwapSessionStatus.FINISHED:
          return 'swap-finished';
        case ChargeConstants.SwapSessionStatus.INITIATING:
          return 'swap-initiating';
        case ChargeConstants.SwapSessionStatus.BATTERY_RETURNED:
        case ChargeConstants.SwapSessionStatus.BATTERY_PICKED_UP:
          return 'swap-success';
        case ChargeConstants.SwapSessionStatus.WAITING_PICK_UP:
          return 'swap-waiting-pickup';
        case ChargeConstants.SwapSessionStatus.WAITING_RETURN:
          return 'swap-waiting-return';
        case ChargeConstants.SwapSessionStatus.PICK_UP_EXPIRED:
        case ChargeConstants.SwapSessionStatus.FAILED:
        case ChargeConstants.SwapSessionStatus.CANCELLED:
          return 'swap-danger';
        default:
          return '';
      }
    },
    /** Lấy chi tiết phiên đổi pin từ dữ liệu mẫu (không gọi API). Trả về object dạng chargeTransaction để tương thích màn chi tiết. */
    getMockSwapSessionDetail: (id) => {
      const list = ChargeHelper.Data.mockSwapSessionList || [];
      const row = list.find((r) => String(r?.swapSessionId) === String(id));
      if (!row) return null;
      return {
        transactionId: row.swapSessionId,
        transactionCode: row.swapSessionCode,
        totalCost: row.serviceFeeVnd,
        estimatedEnergyCost: row.serviceFeeVnd,
        status: row.status,
        startTime: row.startTime,
        endTime: row.endTime,
        energyDiffKwh: row.energyDiffKwh ,
        capacityDiffPercent: row.capacityDiffPercent ,
        vehicle: { plate: row.plate, model: { name: row.vehicleModelName } },
        user: { fullname: row.ownerName, phone: row.phone },
      };
    },
    // ---- TRAM SAC ----
    // lay pin icon tram sac
    getChargeStationPinIcon: (status) => {
      switch (status) {
        case ChargeConstants.ChargeStationStatus.NORMAL:
          return AppResource.icons.pin.normal;
        case ChargeConstants.ChargeStationStatus.MAINTAINING:
          return AppResource.icons.pin.maintaining;
        case ChargeConstants.ChargeStationStatus.PENDING:
          return AppResource.icons.pin.pending;
        case ChargeConstants.ChargeStationStatus.STOPPED:
          return AppResource.icons.pin.stopped;
        case ChargeConstants.ChargeStationStatus.HIDDEN:
          return AppResource.icons.pin.hidden;
        default:
          return AppResource.icons.pin.normal;
      }
    },
    // lay ten trang thai tram sac
    getChargeStationStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeStationStatus.NORMAL:
          return 'Đang hoạt động';
        case ChargeConstants.ChargeStationStatus.MAINTAINING:
          return 'Đang bảo trì';
        case ChargeConstants.ChargeStationStatus.PENDING:
          return 'Đang lắp đặt';
        case ChargeConstants.ChargeStationStatus.STOPPED:
          return 'Ngừng hoạt động';
        case ChargeConstants.ChargeStationStatus.HIDDEN:
          return 'Đang ẩn';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai tram sac
    getChargeStationStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeStationStatus.NORMAL:
          return 'success';
        case ChargeConstants.ChargeStationStatus.MAINTAINING:
          return 'warning';
        case ChargeConstants.ChargeStationStatus.PENDING:
          return 'primary';
        case ChargeConstants.ChargeStationStatus.STOPPED:
          return 'secondary';
        case ChargeConstants.ChargeStationStatus.HIDDEN:
          return 'info';
        default:
          return '';
      }
    },
    // lay ds cac loai tru sac trong 1 tram sac
    getChargeStationPointTypes: (chargeStation) => {
      return _.uniq(chargeStation?.chargePoints?.map((point) => point?.type))?.join(', ');
    },
    // lay tong so tru sac con trong trong 1 tram sac
    getChargeStationAvailablePoints: (chargePoints) => {
      return chargePoints?.length && chargePoints?.filter(
        (point) => point?.status === ChargeConstants.ChargePointStatus.AVAILABLE
      )?.length;
    },
    // lay dia chi day du cua tram sac
    getChargeStationFullAddress: (chargeStation) => {
      const areaTree = store.getState().app.areaTree;
      let address = chargeStation?.address ?? '';
      const leafAreaId =
        chargeStation?.areaId ??
        chargeStation?.wardId ??
        chargeStation?.districtId ??
        chargeStation?.provinceId ??
        null;
      const area = ChargeHelper.Utils.getAreaById([areaTree], leafAreaId);
      if (area) {
        address += ', ' + area?.name ?? '';
        if (area?.typeCode === 'W') {
          const parentArea = ChargeHelper.Utils.getAreaById([areaTree], area?.parentId);
          if (parentArea) {
            address += `, ${parentArea?.name ?? ''}`;
          }
        }
      }
      return address ?? '';
    },

    // ---- TRU SAC ----
    // lay ten trang thai tru sac
    getChargePointStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargePointStatus.AVAILABLE:
        case 'READY':
          return 'Sẵn sàng';
        case ChargeConstants.ChargePointStatus.BUSY:
          return 'Đang bận';
        case ChargeConstants.ChargePointStatus.FAULT:
          return 'Đang lỗi';
        case ChargeConstants.ChargePointStatus.MAINTAINING:
          return 'Đang bảo trì';
        case ChargeConstants.ChargePointStatus.DISCONNECTED:
          return 'Mất kết nối';
        case ChargeConstants.ChargePointStatus.DISABLED:
          return 'Vô hiệu hóa';
        case ChargeConstants.ChargePointStatus.SMOKE_WARNING:
          return 'Cảnh báo khói';
        case ChargeConstants.ChargePointStatus.WATER_WARNING:
          return 'Cảnh báo ngập nước';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai tru sac
    getChargePointStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargePointStatus.AVAILABLE:
        case 'READY':
          return 'ready';
        case ChargeConstants.ChargePointStatus.BUSY:
          return 'busy';
        case ChargeConstants.ChargePointStatus.MAINTAINING:
            return 'maintaining';
        case ChargeConstants.ChargePointStatus.FAULT:
        case ChargeConstants.ChargePointStatus.DISCONNECTED:
          return 'fault';
        case ChargeConstants.ChargePointStatus.DISABLED:
          return 'disabled';
        case ChargeConstants.ChargePointStatus.SMOKE_WARNING:
        case ChargeConstants.ChargePointStatus.WATER_WARNING:
          return 'warning';
        default:
          return '';
      }
    },
    // class bổ sung cho trạng thái tủ pin (vd: gạch chân cho Đang lỗi)
    getChargePointStatusExtraClassName: (status) => {
      switch (status) {
        case ChargeConstants.ChargePointStatus.FAULT:
          return ' charge-point-status-underline';
        default:
          return '';
      }
    },

    // ---- VOI SAC ----
    // lay ten trang thai voi sac
    getChargeConnectorStatusName: (status) => {
      switch (status) {
        case ChargeConstants.ChargeConnectorStatus.AVAILABLE:
          return 'Sẵn sàng';
        case ChargeConstants.ChargeConnectorStatus.PREPARING:
          return 'Đang chuẩn bị';
        case ChargeConstants.ChargeConnectorStatus.CHARGING:
          return 'Đang sạc';
        case ChargeConstants.ChargeConnectorStatus.SUSPENDED:
          return 'Đang tạm dừng';
        case ChargeConstants.ChargeConnectorStatus.FINISHING:
          return 'Đang kết thúc';
        case ChargeConstants.ChargeConnectorStatus.FAULTED:
          return 'Lỗi';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai voi sac
    getChargeConnectorStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.ChargeConnectorStatus.AVAILABLE:
          return 'success';
        case ChargeConstants.ChargeConnectorStatus.PREPARING:
          return 'info';
        case ChargeConstants.ChargeConnectorStatus.CHARGING:
          return 'primary';
        case ChargeConstants.ChargeConnectorStatus.SUSPENDED:
          return 'warning';
        case ChargeConstants.ChargeConnectorStatus.FINISHING:
          return 'danger';
        case ChargeConstants.ChargeConnectorStatus.FAULTED:
          return 'danger';
        default:
          return '';
      }
    },
    // ---- NGĂN PIN (SLOT) ----
    getSlotStatusName: (status) => {
      switch (status) {
        case 'READY':
        case 'AVAILABLE':
          return 'Sẵn sàng';
        case 'READY_CHARGING':
          return 'Sẵn sàng - Đang sạc';
        case 'RESERVED':
          return 'Đang giữ chỗ';
        case 'EMPTY':
          return 'Đang trống';
        case 'CHARGING':
          return 'Đang sạc';
        case 'WAITING_FOR_CHARGE':
        case 'WAITING_CHARGE':
          return 'Chờ sạc';
        case 'CHARGE_PAUSED':
        case 'STOPPING_CHARGE':
          return 'Đang ngừng sạc';
        case 'MAINTENANCE':
        case 'MAINTAINING':
          return 'Đang bảo trì';
        case 'ERROR':
        case 'FAULT':
          return 'Đang lỗi';
        case 'OFFLINE':
          return 'Mất kết nối';
        case 'DISABLED':
          return 'Vô hiệu hóa';
        case 'FULL':
          return 'Đã đầy';
        default:
          return status ?? '';
      }
    },
    getSlotStatusColor: (status) => {
      switch (status) {
        case 'READY':
        case 'AVAILABLE':
        case 'READY_CHARGING':
        case 'FULL':
          return 'success';
        case 'RESERVED':
        case 'MAINTENANCE':
        case 'MAINTAINING':
          return 'warning';
        case 'EMPTY':
        case 'WAITING_FOR_CHARGE':
        case 'WAITING_CHARGE':
        case 'DISABLED':
          return 'secondary';
        case 'CHARGING':
          return 'info';
        case 'CHARGE_PAUSED':
        case 'STOPPING_CHARGE':
          return 'primary';
        case 'ERROR':
        case 'FAULT':
        case 'OFFLINE':
          return 'danger';
        default:
          return 'secondary';
      }
    },
    // lay link QRCode cua voi sac
    getChargeConnectorQRCodeLink: (connector) => {
      const connectorId = connector?.connectorSerial ?? connector?.connectorId;
      const url = `${AppConfigs.env.domainUrl}/prepaid/qr/${connectorId}`;
      return url;
    },
    // lay link ocpp debug
    getChargePointOCPPDebugLink: (chargePoint) => {
      const url = `${AppConfigs.env.baseUrl}logs/${chargePoint?.ocppId}.log`;
      return url;
    },

    // lay link QRCode cua the RFID
    getRFIDQRCodeLink: (serialNumber) => {
      const url = `${AppConfigs.env.domainUrl}/topup/${serialNumber}`;
      return url;
    },

    // ---- THONG BAO ----
    // lay faIcon cua loai thong bao
    getMessageLogTypeIcon: (type) => {
      switch (type) {
        case ChargeConstants.MessageLogType.INFO:
          return 'fa-solid fa-message-lines';
        case ChargeConstants.MessageLogType.NOTICE:
          return 'fa-solid fa-circle-info';
        case ChargeConstants.MessageLogType.WARNING:
          return 'fa-solid fa-triangle-exclamation';
        case ChargeConstants.MessageLogType.ERROR:
          return 'fa-solid fa-triangle-exclamation';
        default:
          return '';
      }
    },
    // lay ten loai thong bao
    getMessageLogTypeName: (type) => {
      switch (type) {
        case ChargeConstants.MessageLogType.INFO:
          return 'Thông tin';
        case ChargeConstants.MessageLogType.NOTICE:
          return 'Thông báo';
        case ChargeConstants.MessageLogType.WARNING:
          return 'Cảnh báo';
        case ChargeConstants.MessageLogType.ERROR:
          return 'Lỗi';
        default:
          return '';
      }
    },
    // lay mau sac cua loai thong bao
    getMessageLogTypeColor: (type) => {
      switch (type) {
        case ChargeConstants.MessageLogType.INFO:
          return 'info';
        case ChargeConstants.MessageLogType.NOTICE:
          return 'primary';
        case ChargeConstants.MessageLogType.WARNING:
          return 'warning';
        case ChargeConstants.MessageLogType.ERROR:
          return 'danger';
        default:
          return '';
      }
    },
    // lay ten cua loai voi sac
    getChargeConnectorTypeName: (type) => {
      switch (type) {
        case ChargeConstants.ChargeConnectorType.J1772:
          return 'J1772 - Type 1';
        case ChargeConstants.ChargeConnectorType.Mennekes:
          return 'Mennekes - Type 2';
        case ChargeConstants.ChargeConnectorType.GB_T:
          return 'GB/T';
        case ChargeConstants.ChargeConnectorType.CHAdeMO:
          return 'CHAdeMO';
        case ChargeConstants.ChargeConnectorType.CCS1:
          return 'CCS1';
        case ChargeConstants.ChargeConnectorType.CCS2:
          return 'CCS2';
        case ChargeConstants.ChargeConnectorType.Tesla:
          return 'Tesla';
        case ChargeConstants.ChargeConnectorType.AC:
          return 'AC';
        default:
          return '';
      }
    },

    // MARK: ---- AREA ----
    // lay thong tin khu vuc tu cay de quy khu vuc
    getAreaById: (areaTree, id) => {
      if (!areaTree) return null;
      const stack = [...areaTree];
      while (stack.length) {
        const node = stack.pop();
        if (node.areaId == id) {
          return node;
        }
        if (node.subAreas) {
          stack.push(...node.subAreas);
        }
      }
      return null;
    },
    // lay ds khu vuc theo type tu cay de quy khu vuc
    getAreaListByType: (areaTree, typeCode) => {
      if (!areaTree) return [];
      const stack = [...areaTree];
      const result = [];
      while (stack.length) {
        const node = stack.pop();
        if (node.typeCode == typeCode) {
          result.push(node);
        }
        if (node.subAreas) {
          stack.push(...node.subAreas);
        }
      }
      return result;
    },
    // lay ds khu vuc con theo parentId tu cay de quy khu vuc
    getSubAreaListByParentId: (areaTree, parentId) => {
      if (!areaTree) return [];
      const stack = [...areaTree];
      const result = [];
      while (stack.length) {
        const node = stack.pop();
        if (node.parentId == parentId) {
          result.push(node);
        }
        if (node.subAreas) {
          stack.push(...node.subAreas);
        }
      }
      return result;
    },
    // lay ten trang thai tai khoan dien luc
    getEnergyAccountStatusName: (status) => {
      switch (status) {
        case ChargeConstants.EnergyAccountStatus.PENDING:
          return 'Chờ phê duyệt';
        case ChargeConstants.EnergyAccountStatus.VALIDATED:
          return 'Đã phê duyệt';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai tai khoan dien luc
    getEnergyAccountStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.EnergyAccountStatus.PENDING:
          return 'danger';
        case ChargeConstants.EnergyAccountStatus.VALIDATED:
          return 'success';
        default:
          return '';
      }
    },

    // ---- TUTORIAL ----
    // lay ten trang thai huong dan su dung
    getTutorialStatusName: (status) => {
      switch (status) {
        case ChargeConstants.TutorialStatus.NORMAL:
          return 'Hoạt động';
        case ChargeConstants.TutorialStatus.DELETED:
          return 'Đang ẩn';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai huong dan su dung
    getTutorialStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.TutorialStatus.NORMAL:
          return 'success';
        case ChargeConstants.TutorialStatus.DELETED:
          return 'info';
        default:
          return '';
      }
    },
    // lay ten loai gia sac xe
    getDriverPricingTypeName: (discountRate) => {
      switch (discountRate) {
        case ChargeConstants.ChargeDriverPricingType.STANDARD:
          return 'Tiêu chuẩn';
        case ChargeConstants.ChargeDriverPricingType.DISCOUNT:
          return 'Ưu đãi';
        case ChargeConstants.ChargeDriverPricingType.FREE:
          return 'Miễn phí';
        default:
          return '';
      }
    },
    // MARK: ---- NOTIFICATION ----
    // lay ten trang thai thong bao
    getNotificationStatusName: (status) => {
      switch (status) {
        case ChargeConstants.NotificationStatus.SCHEDULED:
          return 'Đã lên lịch';
        case ChargeConstants.NotificationStatus.SENT:
          return 'Đã gửi';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai thong bao
    getNotificationStatusColor: (status) => {
      switch (status) {
        case ChargeConstants.NotificationStatus.SCHEDULED:
          return 'info';
        case ChargeConstants.NotificationStatus.SENT:
          return 'primary';
        default:
          return '';
      }
    },
    // lay ten danh muc thong bao
    getNotificationCategoryName: (category) => {
      switch (category) {
        case ChargeConstants.NotificationCategory.BUSINESS:
          return 'Kinh doanh';
        case ChargeConstants.NotificationCategory.OPERATION:
          return 'Vận hành';
        case ChargeConstants.NotificationCategory.PROMOTION:
          return 'Khuyến mãi';
        case ChargeConstants.NotificationCategory.CHARGE:
          return 'Sạc xe & Giao dịch';
        case ChargeConstants.NotificationCategory.OTHER:
          return 'Khác';
        case ChargeConstants.NotificationCategory.EVG:
          return 'EVG';
        default:
          return '';
      }
    },
    // lay ten nguoi nhan
    getNotificationReceiverName: (role) => {
      switch (role) {
        case ChargeConstants.UserRole.DRIVER:
          return 'Tất cả tài xế';
        case ChargeConstants.UserRole.AGENCY:
          return 'Tất cả đối tác';
        case AgencyConstants.AgencyRole.SALE:
          return 'Tất cả đại lý';
        case AgencyConstants.AgencyRole.INVESTOR:
          return 'Tất cả NĐT nhượng quyền';
        case AgencyConstants.AgencyRole.GROUP:
          return 'Tất cả nhà đầu tư HTKD';
        case AgencyConstants.AgencyRole.LANDLORD:
          return 'Tất cả chủ mặt bằng';
        default:
          return '';
      }
    },
  },

  // MARK: ---- NAVIGATION ----
  Navigation: {
    // chuyen den man them tram sac
    navigateToAddChargeStation: (router) => {
      if (router) {
        router.navigate(`${AppRoute.stationList}/add`);
      }
    },
    // chuyen den man chinh sua tram sac
    navigateToEditChargeStation: (router, chargeStationId) => {
      if (router) {
        router.navigate(`${AppRoute.stationList}/${chargeStationId}/edit`);
      }
    },
    // chuyen den man chi tiet tram sac
    navigateToChargeStationDetail: (router, chargeStationId) => {
      if (router) {
        router.navigate(`${AppRoute.stationList}/${chargeStationId}`);
      } else {
        Utils.openInNewTab(`${AppRoute.stationList}/${chargeStationId}`);
      }
    },
  },

  // MARK: ---- UI ----
  UI: {
    // ---- PRICING ----
    Pricing: {
      // hien dialog xac nhan xoa dinh gia
      showDialogConfirmDeletePricing: (pricingDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá định giá"
            contentEl={
              <>
                Bạn có chắc muốn xoá định giá:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {pricingDetail?.pricingId}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              try {
                const result = await ChargeHelper.API.requestDeleteChargePricing(
                  pricingDetail?.pricingId
                );
                if (result && _.isBoolean(result)) {
                  ToastHelper.showSuccess('Xoá định giá thành công');
                  if (onDone) {
                    onDone();
                  }
                } else {
                  ToastHelper.showError(result || 'Xoá định giá thất bại');
                }
              } catch (error) {
                if (_.isString(error)) {
                  ToastHelper.showError(error);
                }
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // ---- TRAM SAC ----
    // hien dialog xac nhan xoa tram sac
    showDialogConfirmDeleteChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá trạm đổi pin"
          confirmButtonText="Xoá"
          confirmButtonRed={true} 
          contentEl={
            <>
              Bạn có chắc muốn xoá trạm {' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                {chargeStationDetail?.name}
              </span>
              {' '}không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            try {
              const result = await ChargeHelper.API.requestDeleteChargeStation(
                chargeStationDetail?.stationId
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá trạm đổi pin thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá trạm đổi pin thất bại');
              }
            } catch (error) {
              if (_.isString(error)) {
                ToastHelper.showError(error);
              }
            }
          }}
          // confirmButtonText='Xóa'
          // confirmButtonRed={true}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan ngung hoat dong tram sac
    showDialogConfirmStopChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogStopChargeStationView
          item={chargeStationDetail}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan an tram sac
    showDialogConfirmHideChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngImgDialogHideStation} />}
          title="Ẩn trạm đổi pin"
          confirmButtonText="Ẩn"
          confirmButtonRed={true}
          contentEl={
            <>
              Trạm đổi pin sau khi ẩn sẽ không hiện trên ứng dụng của khách hàng.{' '}
              {/* <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                {chargeStationDetail?.name}{' '}
              </span>
              ? */}
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              { status: ChargeConstants.ChargeStationStatus.HIDDEN }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Ẩn trạm đổi pin thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Ẩn trạm sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan bo an tram sac
    showDialogConfirmUnhideChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngImgDialogUnHideStation} />}
          title="Bỏ ẩn trạm đổi pin"
          confirmButtonText="Bỏ ẩn"
          contentEl={
            <>
              Hệ thống sẽ khôi phục hiển thị trạm đổi pin này tới danh sách các trạm đổi pin đang hoạt động, mọi thông tin và tính năng của trạm đổi pin sẽ hoạt động lại bình thường.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              {
                status: ChargeConstants.ChargeStationStatus.NORMAL,
                reason: null,
                operationalDate: null,
              }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Bỏ ẩn trạm đổi pin thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Bỏ ẩn trạm đổi pin thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan bao tri tram sac
    showDialogConfirmMaintainChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngDialogMaintenance} />}
          title="Bảo trì trạm đổi pin"
          confirmButtonText="Bảo trì"
          confirmButtonRed={true}
          contentEl={
            <>
              Việc bảo trì trạm sẽ dẫn đến toàn bộ tủ pin, ngăn pin và pin trong trạm chuyển trạng thái tương ứng, tài xế và khách hàng sẽ không thể thực hiện bất kỳ giao dịch đổi pin nào tại trạm này. Bạn vẫn muốn tiếp tục?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              {
                status: ChargeConstants.ChargeStationStatus.MAINTAINING,
                reason: null,
                operationalDate: null,
              }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Bảo trì trạm đổi pin thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Bảo trì trạm đổi pin thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan hoan thanh bao tri tram sac
    showDialogConfirmCompleteMaintenanceChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngDialogDoneMaintenance} />}
          title="Hoàn thành bảo trì"
          confirmButtonText="Xác nhận"
          contentEl={
            <>
              Hệ thống sẽ chuyển trạm đổi pin sang trạng thái{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', undefined, AppColors.gray[600])}
                onClick={() => { }}
              >
                Đang hoạt động
              </span>
              , cho phép toàn bộ thông tin và các tính năng của trạm trở lại vận hành bình thường.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              {
                status: ChargeConstants.ChargeStationStatus.NORMAL,
                reason: null,
                operationalDate: null,
              }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Hoàn thành bảo trì trạm đổi pin thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Hoàn thành bảo trì trạm đổi pin thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan khoi phuc hoat dong tram sac
    showDialogConfirmRestoreChargeStation: (chargeStationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogActiveAgency} />}
          title="Khôi phục hoạt động"
          confirmButtonText="Khôi phục hoạt động"
          cancelButtonText = "Hủy bỏ"
          contentEl={
            <>
              Bạn có chắc muốn khôi phục hoạt động{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', undefined, AppColors.gray[600])}
                onClick={() => { }}
              >
                {chargeStationDetail?.name}
              </span>
              {' '}không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargeStation(
              chargeStationDetail?.stationId,
              {
                status: ChargeConstants.ChargeStationStatus.NORMAL,
                reason: null,
                operationalDate: null,
              }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Khôi phục hoạt động trạm đổi pin thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Khôi phục hoạt động trạm đổi pin thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // ---- TU PIN ----
    // hien dialog xac nhan xoa tu pin
    showDialogConfirmDeleteChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngDeleteCabinet} />}
          title="Xoá tủ pin"
          confirmButtonText="Xoá"
          confirmButtonRed={true}
          contentEl={
            <>
              Bạn có chắc muốn xoá tủ pin {' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {chargePointDetail?.pointCode}
              </span>
              {' '} không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteChargePoint(
              chargePointDetail?.pointId
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá tủ pin thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá tủ pin thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // Khóa cửa ngăn pin - popup xác nhận giống đóng công tắc sạc tạm thời
    showDialogConfirmLockSlot: (slotRow, _cabinetId, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogLockSlotDoorView
          slotRow={slotRow}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // Mở cửa ngăn pin - popup xác nhận dùng icon vngOpen
    showDialogConfirmUnlockSlot: (slotRow, _cabinetId, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogOpenSlotDoorView
          slotRow={slotRow}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // Ngắt sạc ngăn pin - popup xác nhận dùng icon vngTurnOff
    showDialogConfirmStopSlotCharging: (slotRow, _cabinetId, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogStopSlotChargingView
          slotRow={slotRow}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // Bật sạc ngăn pin - popup xác nhận dùng icon vngTurnOn
    showDialogConfirmStartSlotCharging: (slotRow, _cabinetId, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogStartSlotChargingView
          slotRow={slotRow}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // khoi dong lai ngan pin (khac voi khoi dong lai tu pin)
    showDialogConfirmRestartSlot: (slotRow, cabinetId, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngRotateRight} />}
          title="Khởi động lại ngăn pin"
          cancelButtonText="Hủy bỏ"
          confirmButtonText="Khởi động lại"
          contentEl={
            <>
              Hệ thống sẽ khởi động lại trạng thái thực tế của ngăn pin, cho phép toàn bộ thông tin và các tính năng của ngăn pin trở lại vận hành bình thường.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const id = cabinetId ?? slotRow?.cabinetId;
            const slotId = slotRow?.slotId ?? slotRow?.id;
            if (!id || slotId == null) {
              ToastHelper.showError('Không tìm thấy thông tin ngăn pin');
              return;
            }
            const result = await ChargeHelper.API.requestUpdateSlotStatus(id, slotId, 'READY');
            if (result === true) {
              ToastHelper.showSuccess('Khởi động lại ngăn pin thành công');
              if (onDone) onDone();
              return;
            }
            ToastHelper.showError(_.isString(result) ? result : 'Khởi động lại ngăn pin thất bại');
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hoàn thành bảo trì ngăn pin - icon vngDialogDoneMaintenance
    showDialogConfirmCompleteMaintenanceSlot: (slotRow, cabinetId, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngDialogDoneMaintenance} />}
          title="Hoàn thành bảo trì"
          cancelButtonText="Hủy bỏ"
          confirmButtonText="Xác nhận"
          contentEl={
            <>
              Hệ thống sẽ khởi động lại trạng thái thực tế của ngăn pin, cho phép toàn bộ thông tin và các tính năng của ngăn pin trở lại vận hành bình thường.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const id = cabinetId ?? slotRow?.cabinetId;
            const slotId = slotRow?.slotId ?? slotRow?.id;
            if (!id || slotId == null) {
              ToastHelper.showError('Không tìm thấy thông tin ngăn pin');
              return;
            }
            const result = await ChargeHelper.API.requestUpdateSlotStatus(id, slotId, 'READY');
            if (result === true) {
              ToastHelper.showSuccess('Hoàn thành bảo trì ngăn pin thành công');
              if (onDone) onDone();
              return;
            }
            ToastHelper.showError(_.isString(result) ? result : 'Hoàn thành bảo trì ngăn pin thất bại');
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan khoi dong lai tu pin
    showDialogConfirmRestartChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngRotateRight} />}
          title="Khởi động lại tủ pin"
          contentEl={
            <>
              Bạn có chắc muốn khởi động lại tủ pin:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {chargePointDetail?.pointCode}
              </span>
              {' '}không?
            </>
          }
          confirmButtonText = "Khởi động lại"
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const isCabinet =
              !!chargePointDetail?.cabinetId ||
              !!chargePointDetail?.cabinetCode ||
              !!chargePointDetail?.cabinetModel;
            const cabinetId = chargePointDetail?.cabinetId ?? chargePointDetail?.pointId;

            const result = isCabinet
              ? await ChargeHelper.API.requestRestartCabinet(cabinetId)
              : await ChargeHelper.API.requestRestartChargePoint(chargePointDetail?.pointId);
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Khởi động lại tủ pin thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Khởi động lại tủ pin thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan thiet lap gioi han cong suat cua tru sac
    showDialogConfirmSetPowerLimitChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <ChargePointSetLimitPowerView
          chargePointDetail={chargePointDetail}
          title="Thiết lập công suất trụ sạc"
          contentEl={
            <>
              Nhập mức công suất giới hạn cho trụ sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {chargePointDetail?.pointCode}
              </span>
              ?
            </>
          }
          iconEl={<img src={AppResource.images.dialogIcons.dialogLimitPower} />}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async (powerLimit) => {
            AppCustomDialogHelper.hide();
            console.log({ powerLimit });
            const result = await ChargeHelper.API.requestSetChargePointPowerLimit(
              chargePointDetail?.pointId,
              powerLimit
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Thiết lập công suất trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Thiết lập công suất trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },

    // thiet lap nguong canh bao (tu pin)
    showDialogWarningThresholdCabinet: (cabinetDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogWarningThresholdCabinetView
          item={cabinetDetail}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) onDone();
          }}
        />,
        'md',
        true,
        true
      );
    },
    // điều chỉnh ngưỡng cảnh báo nhiệt độ (ngăn pin)
    showDialogWarningThresholdSlot: (slotRow, _cabinetId, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogWarningThresholdSlotView
          slotRow={slotRow}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) onDone();
          }}
        />,
        'md',
        true,
        true
      );
    },
    // vô hiệu hóa ngăn pin - popup với icon vngDisabled
    showDialogConfirmDisableSlot: (slotRow, _cabinetId, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogDisableSlotView
          slotRow={slotRow}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) onDone();
          }}
        />,
        'md',
        true,
        true
      );
    },
    // Thêm pin vào ngăn - form hãng, loại pin, serial, mã định vị
    showDialogAddBatteryToSlot: (slotRow, cabinetId, onDone) => {
      const slotLabel =
        slotRow?.slotNumber != null
          ? `Ngăn số ${slotRow.slotNumber}`
          : slotRow?.slotCode ?? (slotRow?.slotId != null ? `SL${String(slotRow.slotId).padStart(8, '0')}` : '');
      const title = `Thêm pin vào ngăn • ${slotLabel}`;
      AppCustomDialogHelper.show(
        title,
        <DialogAddBatteryToSlotView
          slotRow={slotRow}
          cabinetId={cabinetId}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) onDone();
          }}
        />,
        'md',
        false,
        true,
        true
      );
    },
    // hien dialog xac nhan di chuyen tu pin
    showDialogConfirmMoveChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogMovePointView
          chargePointDetail={chargePointDetail}
          title={<span style={UIHelper.buildFontStyle('600', '16px', undefined, AppColors.gray[800])}>Di chuyển tủ pin</span>}
          contentEl={<span style={UIHelper.buildFontStyle('400', '14px', undefined, AppColors.gray[600])}>Vui lòng chọn thông tin trạm đổi pin mà bạn muốn di chuyển tủ pin tới</span>}
          iconEl={<img src={AppResource.vng.vngMove} />}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async (stationId) => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateCabinet(chargePointDetail?.pointId, {
              stationId: stationId,
            });
            if (result?.result === 'success' || result === true) {
              ToastHelper.showSuccess('Di chuyển tủ pin thành công');
              if (onDone) onDone();
              return;
            }
            ToastHelper.showError(_.isString(result) ? result : result?.reason || 'Di chuyển tủ pin thất bại');
          }}
        />,
        'md',
        false,
        true
      );
    },

    // thiet lap lich bao tri dinh ky (tu pin)
    showDialogScheduledMaintenanceCabinet: (cabinetDetail, onDone) => {
      AppCustomDialogHelper.show(
        'Thiết lập lịch bảo trì định kỳ',
        <DialogScheduledMaintenanceCabinetView
          chargePointDetail={cabinetDetail}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async (payload) => {
            AppCustomDialogHelper.hide();
            try {
              const requestBody = {
                stationId: payload?.stationId,
                cabinetId: payload?.cabinetId,
                startDate: payload?.startDate,
                cycle: payload?.cycle,
                description: payload?.description,
                applyToAllCabinets: payload?.applyToAllCabinets,
              };

              const result = await ChargeHelper.API.requestCreateMaintenanceSchedule(requestBody);
              
              if (_.isString(result) || (result && result?.result && result?.result !== 'success')) {
                ToastHelper.showError(_.isString(result) ? result : 'Thiết lập lịch bảo trì định kỳ thất bại');
                return;
              }
              
              ToastHelper.showSuccess('Thiết lập lịch bảo trì định kỳ thành công');
              if (onDone) onDone();
            } catch (error) {
              ToastHelper.showError(_.isString(error) ? error : 'Thiết lập lịch bảo trì định kỳ thất bại');
            }
          }}
        />,
        '',
        false,
        true,
        false,
        'scheduled-maintenance-dialog'
      );
    },

    // chuyen trang thai bao tri ngan pin (khac voi bao tri tu pin)
    showDialogConfirmMaintenanceSlot: (slotRow, cabinetId, onDone) => {
      const slotCode = slotRow?.slotCode ?? (slotRow?.slotId != null ? `SL${String(slotRow.slotId).padStart(8, '0')}` : '');
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngDialogMaintenance} />}
          title="Bảo trì ngăn pin"
          cancelButtonText="Hủy bỏ"
          confirmButtonText="Bảo trì"
          confirmButtonRed={true}
          contentEl={
            <>
              Bạn có chắc muốn chuyển trạng thái ngăn pin{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => {}}
              >
                {slotCode || '[Mã ngăn pin]'}
              </span>{' '}
              thành &quot;Đang bảo trì&quot; không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const id = cabinetId ?? slotRow?.cabinetId;
            const slotId = slotRow?.slotId ?? slotRow?.id;
            if (!id || slotId == null) {
              ToastHelper.showError('Không tìm thấy thông tin ngăn pin');
              return;
            }
            const result = await ChargeHelper.API.requestUpdateSlotStatus(id, slotId, 'MAINTAINING');
            if (result === true) {
              ToastHelper.showSuccess('Chuyển trạng thái bảo trì ngăn pin thành công');
              if (onDone) onDone();
              return;
            }
            ToastHelper.showError(_.isString(result) ? result : 'Chuyển trạng thái bảo trì ngăn pin thất bại');
          }}
        />,
        'md',
        true,
        true
      );
    },

    // chuyen trang thai bao tri tu pin
    showDialogConfirmMaintenanceCabinet: (cabinetDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngDialogMaintenance} />}
          title="Bảo trì tủ pin"
          confirmButtonText="Bảo trì"
          confirmButtonRed = "true"
          contentEl={
            <>
              Việc bảo trì tủ sẽ dẫn đến toàn ngăn pin trong tủ chuyển trạng thái tương ứng, tài xế và khách hàng sẽ không thể thực hiện bất kỳ giao dịch đổi pin nào tại tủ này. Bạn vẫn muốn tiếp tục?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateCabinet(cabinetDetail?.pointId, {
              status: ChargeConstants.ChargePointStatus.MAINTAINING,
              reason: null,
            });
            if (result?.result === 'success' || result === true) {
              ToastHelper.showSuccess('Chuyển trạng thái bảo trì tủ pin thành công');
              if (onDone) onDone();
              return;
            }
            ToastHelper.showError(_.isString(result) ? result : result?.reason || 'Chuyển trạng thái bảo trì tủ pin thất bại');
          }}
        />,
        'md',
        true,
        true
      );
    },

    // hoan thanh bao tri tu pin
    showDialogConfirmCompleteMaintenanceCabinet: (cabinetDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngDialogDoneMaintenance} />}
          title="Hoàn thành bảo trì"
          confirmButtonText="Xác nhận"
          contentEl={
            <>
              {/* Bạn có chắc muốn hoàn thành bảo trì tủ pin{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {cabinetDetail?.pointCode}
              </span>{' '}
              không? */}
              Hệ thống sẽ khởi động lại trạng thái thực tế của tủ pin, cho phép toàn bộ thông tin và các tính năng của tủ pin trở lại vận hành bình thường.
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateCabinet(cabinetDetail?.pointId, {
              status: 'READY',
              reason: null,
            });
            if (result?.result === 'success' || result === true) {
              ToastHelper.showSuccess('Hoàn thành bảo trì tủ pin thành công');
              if (onDone) onDone();
              return;
            }
            ToastHelper.showError(_.isString(result) ? result : result?.reason || 'Hoàn thành bảo trì tủ pin thất bại');
          }}
        />,
        'md',
        true,
        true
      );
    },

    // vo hieu hoa tu pin
    showDialogConfirmDisableCabinet: (cabinetDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.vng.vngDisabled} />}
          title="Vô hiệu hóa tủ pin"
          confirmButtonText="Vô hiệu hóa"
          confirmButtonRed={true}
          contentEl={
            <>
              <span style={{ whiteSpace: 'nowrap' }}>
                Bạn có chắc muốn vô hiệu hóa tủ pin{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {cabinetDetail?.pointCode}
                </span>{' '}không?
              </span>
              <div className="mt-2">
                Trong quá trình vô hiệu hóa, hệ thống sẽ ngắt dòng sạc, đóng cửa tủ pin,... và không cho phép diễn ra các giao dịch đổi pin.
              </div>
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateCabinet(cabinetDetail?.pointId, {
              status: ChargeConstants.ChargePointStatus.DISABLED,
              reason: null,
            });
            if (result?.result === 'success' || result === true) {
              ToastHelper.showSuccess('Vô hiệu hóa tủ pin thành công');
              if (onDone) onDone();
              return;
            }
            ToastHelper.showError(_.isString(result) ? result : result?.reason || 'Vô hiệu hóa tủ pin thất bại');
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan thay doi tram sac
    showDialogConfirmChangeChargeStation: (chargeStationDetail, callback) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogNoticeTriangular} />}
          title="Thay đổi trạm sạc quản lý"
          contentEl={
            <>
              Bạn có chắc muốn thay đổi trạm sạc quản lý hiện tại thành trạm sạc{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                {chargeStationDetail?.item?.stationCode ?? 'Không xác định'}
              </span>
              {' '}không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
            callback(false);
          }}
          onConfirm={() => {
            AppCustomDialogHelper.hide();
            callback(true);
          }}
          confirmButtonRed={true}
          confirmButtonText="Thay đổi"
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan bao loi tru sac
    showDialogConfirmReportErrorChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogReportErrorChargePointView
          item={chargePointDetail}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan khoi phuc hoat dong tru sac
    showDialogConfirmRestoreChargePoint: (chargePointDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogRefresh} />}
          title="Khôi phục hoạt động trụ sạc"
          contentEl={
            <>
              Bạn có chắc muốn khôi phục hoạt động của trụ sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {chargePointDetail?.pointCode}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateChargePoint(
              chargePointDetail?.pointId,
              {
                status: ChargeConstants.ChargePointStatus.AVAILABLE,
                reason: null,
              }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Khôi phục hoạt động trụ sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Khôi phục hoạt động trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // ---- VOI SAC ----
    // hien dialog xac nhan xoa voi sac
    showDialogConfirmDeleteChargeConnector: (chargeConnectorDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá vòi sạc"
          contentEl={
            <>
              Bạn có chắc muốn xoá vòi sạc:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                Vòi sạc {chargeConnectorDetail?.connectorNumber}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteChargeConnector(
              chargeConnectorDetail?.pointId,
              chargeConnectorDetail?.connectorId
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá vòi sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá vòi sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien thi dialog xac nhan dung sac
    showDialogConfirmStopChargeConnector: (chargeConnectorDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogStopCharge} />}
          title="Dừng sạc"
          confirmButtonRed={true}
          contentEl={
            <>
              Hệ thống sẽ ngắt cấp điện và ngừng kết nối vòi sạc để hoàn tất phiên sạc. Bạn có chắc
              chắn muốn dừng sạc không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestStopChargeConnector(
              chargeConnectorDetail?.pointId,
              chargeConnectorDetail?.connectorNumber
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Dừng sạc thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Dừng sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan kich hoat voi sac
    showDialogConfirmActivateChargeConnector: (chargePricing, chargeConnectorDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <DialogActivateChargeConnectorView
          pricing={chargePricing}
          item={chargeConnectorDetail}
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onDone={() => {
            AppCustomDialogHelper.hide();
            if (onDone) {
              onDone();
            }
          }}
        />,
        'lg',
        false,
        true
      );
    },

    // ---- HANG SAN XUAT TRU SAC ----
    // hien dialog xac nhan xoa hang san xuat tru sac
    showDialogConfirmDeleteChargeBrand: (chargeBrand, onDone, isCabinetBrand = false) => {
      const title = isCabinetBrand ? 'Xoá hãng sản xuất tủ pin' : 'Xoá hãng sản xuất pin';
      const contentText = isCabinetBrand ? 'hãng sản xuất tủ pin' : 'hãng sản xuất pin';
      const successMessage = isCabinetBrand 
        ? 'Xoá hãng sản xuất tủ pin thành công'
        : 'Xoá hãng sản xuất pin thành công';
      const errorMessage = isCabinetBrand
        ? 'Xoá hãng sản xuất tủ pin thất bại'
        : 'Xoá hãng sản xuất pin thất bại';

      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title={title}
          contentEl={
            <>
              Bạn có chắc muốn xóa {contentText}{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.dangerActive)}
                onClick={() => { }}
              >
                {chargeBrand?.name}
              </span>
              {' '}không?
            </>
          }
          confirmButtonRed = "true"
          confirmButtonText = "Xoá"
          cancelButtonText = "Bỏ qua"
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            // Sử dụng API khác nhau tùy theo loại brand
            const result = isCabinetBrand
              ? await ChargeHelper.API.requestDeleteCabinetBrand(chargeBrand?.brandId)
              : await ChargeHelper.API.requestDeleteChargeBrand(chargeBrand?.brandId);
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess(successMessage);
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || errorMessage);
            }
          }}
        />,
        'md',
        true,
        true
      );
    },

    // ---- DONG TRU SAC ----
    // hien dialog xac nhan xoa dong tru sac
    showDialogConfirmDeleteChargeModel: (chargeModel, onDone, isBatteryBrand = false, brandId = null) => {
      const title = isBatteryBrand ? 'Xoá loại pin' : 'Xoá dòng tủ pin';
      const successMessage = isBatteryBrand ? 'Xoá loại pin thành công' : 'Xoá dòng tủ pin thành công';
      const itemName = isBatteryBrand ? 'mã loại pin' : 'mã dòng tủ pin';
      
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title={title}
          contentEl={
            <>
              Bạn có chắc muốn xoá {itemName}:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.dangerActive)}
                onClick={() => { }}
              >
                {chargeModel?.modelCode || chargeModel?.name}
              </span>
              ?
            </>
          }
          confirmButtonRed = "true"
          cancelButtonText = "Bỏ qua"
          confirmButtonText = "Xoá"
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            let result;
            if (isBatteryBrand) {
              result = await ChargeHelper.API.requestDeleteBatteryBrandModel(brandId, chargeModel?.modelId);
            } else {
              result = await ChargeHelper.API.requestDeleteCabinetBrandModel(brandId, chargeModel?.modelId);
            }
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess(successMessage);
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá model trụ sạc thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },

    // ---- TAI KHOAN DIEN LUC ----
    // hien dialog xac nhan xoa tai khoan dien luc
    showDialogConfirmDeleteEnergyAccount: (energyAccount, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá tài khoản điện lực"
          contentEl={
            <>
              Bạn có chắc muốn xoá tài khoản điện lực:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                onClick={() => { }}
              >
                {energyAccount?.evnCustomerId}
              </span>
              {' '}không?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestDeleteEnergyAccount(
              energyAccount?.energyAccountId
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá tài khoản điện lực thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá tài khoản điện lực thất bại');
            }
          }}
          confirmButtonRed={true}
          confirmButtonText='Xóa'
        />,
        'md',
        true,
        true
      );
    },
    // hien dialog xac nhan phe duyet tai khoan dien luc
    showDialogConfirmApproveEnergyAccount: (energyAccount, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
          title="Phê duyệt tài khoản điện lực"
          contentEl={
            <>
              Bạn có chắc muốn phê duyệt tài khoản điện lực:{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => { }}
              >
                {energyAccount?.evnCustomerId}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await ChargeHelper.API.requestUpdateEnergyAccount(
              energyAccount?.energyAccountId,
              { status: ChargeConstants.EnergyAccountStatus.VALIDATED }
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Phê duyệt tài khoản điện lực thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Phê duyệt tài khoản điện lực thất bại');
            }
          }}
        />,
        'md',
        true,
        true
      );
    },

    // MARK: ---- HANG XE ----
    VehicleBrand: {
      // hien dialog xac nhan xoa hang xe
      showDialogConfirmDeleteVehicleBrand: (vehicleBrand, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá hãng xe"
            confirmButtonRed={true}
            contentEl={
              <>
                Bạn có chắc muốn xoá hãng xe:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {vehicleBrand?.name}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result =
                await ChargeHelper.API.ChargeVehicleBrand.requestDeleteChargeVehicleBrand(
                  vehicleBrand?.brandId
                );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá hãng xe thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá hãng xe thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // MARK: ---- DONG XE ----
    VehicleModel: {
      // hien dialog xac nhan xoa dong xe
      showDialogConfirmDeleteVehicleModel: (vehicleBrandId, vehicleModel, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá dòng xe"
            confirmButtonRed={true}
            contentEl={
              <>
                Bạn có chắc muốn xoá dòng xe:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {vehicleModel?.name}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result =
                await ChargeHelper.API.ChargeVehicleModel.requestDeleteChargeVehicleModel(
                  vehicleBrandId,
                  vehicleModel?.modelId
                );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá dòng xe thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá dòng xe thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // MARK: ---- XE ----
    Vehicle: {
      // hien dialog xac nhan xoa xe
      showDialogConfirmDeleteVehicle: (vehicle, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá xe"
            confirmButtonRed = 'true'
            contentEl={
              <>
                Bạn có chắc muốn xoá xe:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {vehicle?.plate}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Vehicle.requestDeleteVehicle(
                vehicle?.vehicleId
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá xe thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá xe thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan doi the RFID
      showDialogConfirmChangeRFID: (vehicle, onDone) => {
        const cards = vehicle?.cards;
        const modeChangeCard = (cards?.length ?? 0) >= 1;
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={
              <img
                src={
                  modeChangeCard
                    ? AppResource.images.dialogIcons.dialogChangeCard
                    : AppResource.images.dialogIcons.dialogProvideCard
                }
              />
            }
            title={modeChangeCard ? 'Đổi thẻ RFID' : 'Cấp mới thẻ RFID'}
            contentEl={
              modeChangeCard ? (
                <>
                  Bạn có chắc muốn đổi lại thẻ RFID này không? <br />
                  Sau khi đổi, thẻ RFID cũ sẽ bị thu hồi và thay thế bằng thẻ RFID mới.
                </>
              ) : (
                <>
                  Chọn thẻ RFID cho xe {' '}
                  <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                    {vehicle?.plate}
                  </span>
                  {' '} và nhấn xác nhận để hoàn thành.
                </>
              )
            }
            bodyEl={
              <DialogChangeRfidCardView
                vehicle={vehicle}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
    },

    // MARK: ---- RFID ----
    RFID: {
      // hien dialog xac nhan thu hoi the RFID
      showDialogConfirmRevokeRFID: (rfid, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRevokeCard} />}
            title="Thu hồi thẻ RFID"
            confirmButtonRed={true}
            confirmButtonText="Thu hồi"
            contentEl={
              <>
                Bạn có chắc muốn thu hồi thẻ RFID:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {rfid?.idTag}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.RFID.requestUpdateRFIDCard(rfid?.rfidId, {
                vehicleId: null,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Thu hồi thẻ RFID thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Thu hồi thẻ RFID thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan khoi phuc the RFID
      showDialogConfirmRestoreRFID: (rfid, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidRestore} />}
            title="Khôi phục thẻ RFID"
            confirmButtonText="Khôi phục"
            contentEl={
              <>
                Bạn có chắc muốn khôi phục hoạt động thẻ RFID:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {rfid?.idTag}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.RFID.requestUpdateRFIDCard(rfid?.rfidId, {
                status: ChargeConstants.RFIDCardStatus.NORMAL,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Khôi phục thẻ RFID thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Khôi phục thẻ RFID thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan khoa the RFID
      showDialogConfirmLockRFID: (rfid, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidLock} />}
            title="Khoá thẻ RFID"
            confirmButtonRed={true}
            confirmButtonText="Khoá"
            contentEl={
              <>
                Bạn có chắc muốn khoá thẻ RFID:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {rfid?.idTag}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.RFID.requestUpdateRFIDCard(rfid?.rfidId, {
                status: ChargeConstants.RFIDCardStatus.BLOCKED,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Khoá thẻ RFID thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Khoá thẻ RFID thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan xoa the RFID
      showDialogConfirmDeleteRFID: (rfid, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogRfidDelete} />}
            title="Xóa thẻ RFID"
            confirmButtonRed={true}
            cancelButtonText="Bỏ qua"
            confirmButtonText="Xóa"
            contentEl={
              <>
                Bạn có chắc muốn xóa thẻ RFID{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {rfid?.idTag}
                </span>{' '}
                không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.RFID.requestDeleteRFIDCard(rfid?.rfidId);
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xóa thẻ RFID thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xóa thẻ RFID thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // MARK: ---- DRIVER ----
    Driver: {
      // hien dialog xac nhan xoa khach hang
      showDialogConfirmDeleteDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá khách hàng"
            confirmButtonRed={true} 
            contentEl={
              <>
                Bạn có chắc muốn xoá khách hàng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Driver.requestDeleteDriver(driver?.userId);
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xoá khách hàng thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xoá khách hàng thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan ngung hoat dong khach hang
      showDialogConfirmSuspendDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogStopAgency} />}
            title="Ngừng hoạt động"
            contentEl={
              <>
                Bạn có chắc muốn ngừng hoạt động KH{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}
                </span>{' '}
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Ngừng hoạt động"
            confirmButtonRed={true}
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Driver.requestUpdateDriver(driver?.userId, {
                status: ChargeConstants.ChargeDriverStatus.SUSPENDED,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Ngừng hoạt động thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Ngừng hoạt động thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan khoi phuc hoat dong khach hang
      showDialogConfirmResumeDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogActiveAgency} />}
            title="Khôi phục hoạt động"
            contentEl={
              <>
                Bạn có chắc muốn khôi phục hoạt động KH{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}
                </span>{' '}
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Khôi phục"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Driver.requestUpdateDriver(driver?.userId, {
                status: ChargeConstants.ChargeDriverStatus.NORMAL,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Khôi phục khách hàng thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Khôi phục khách hàng thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog xac nhan kich hoat khach hang
      showDialogConfirmActivateDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogAcceptAgency} />}
            title="Kích hoạt tài khoản"
            contentEl={
              <>
                Bạn có chắc muốn kích hoạt tài khoản KH{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}{' '}
                </span>
                không?
              </>
            }
            cancelButtonText="Bỏ qua"
            confirmButtonText="Kích hoạt"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Driver.requestUpdateDriver(driver?.userId, {
                status: ChargeConstants.ChargeDriverStatus.NORMAL,
              });
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Kích hoạt tài khoản thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Kích hoạt tài khoản thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien dialog nap tien cho khach hang
      showDialogTopUpDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogTopUp} />}
            title="Nạp tiền cho khách hàng"
            contentEl={
              <>
                Nhập số tiền để nạp vào ví của khách hàng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {driver?.fullname}
                </span>
              </>
            }
            bodyEl={
              <DialogTopUpDriverView
                driver={driver}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
      // hien dialog dat gia sac xe cho khach hang
      showDialogSetChargingPrice: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogSetChargingPrice} />}
            title="Đặt giá sạc xe"
            contentEl={
              <>
                Chọn loại giá sạc được áp dụng cho khách hàng mỗi lần sạc xe.
              </>
            }
            bodyEl={
              <DialogSetChargingPriceView
                driver={driver}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
      // hien dialog doi mat khau cho khach hang
      showDialogChangePasswordDriver: (driver, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogChangePassword} />}
            title="Đặt lại mật khẩu"
            contentEl={
              <>
                Thay đổi mật khẩu đăng nhập cho tài khoản khách hàng
              </>
            }
            bodyEl={
              <DialogChangeAgencyPasswordView
                agency={driver}
                isDriver={true}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
            removeFooter={true}
          />,
          'md',
          false,
          true
        );
      },
      // hien dialog chi tiet giao dich
      showDialogTransactionDetail: (row, user, onDone) => {
        AppCustomDialogHelper.show(
          'Chi tiết giao dịch',
          <AgencySaleDialogView
            confirmButtonText={null}
            cancelButtonText="Bỏ qua"
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onlyBodyEl={true}
            bodyEl={
              <DialogTransactionDetailView
                item={row}
                user={user}
                onCancel={() => {
                  AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                  AppCustomDialogHelper.hide();
                  if (onDone) {
                    onDone();
                  }
                }}
              />
            }
          />,
          'md',
          false,
          true
        );
      },
    },

    // MARK: ---- THIET BI ----
    Inventory: {
      showDialogConfirmDeleteCategory: (categoryDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá sản phẩm"
            contentEl={
              <>
                Bạn có chắc muốn xoá sản phẩm:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {categoryDetail?.name ?? ''}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              try {
                const result = await ChargeHelper.API.requestDeleteChargeInventoryCategory(
                  categoryDetail?.categoryId
                );
                if (result && _.isBoolean(result)) {
                  ToastHelper.showSuccess('Xoá sản phẩm thành công');
                  if (onDone) {
                    onDone();
                  }
                } else {
                  ToastHelper.showError(result || 'Xoá sản phẩm thất bại');
                }
              } catch (error) {
                if (_.isString(error)) {
                  ToastHelper.showError(error);
                }
              }
            }}
          />,
          'md',
          true,
          true
        );
      },

      showDialogConfirmDeleteInventory: (inventoryDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xoá thiết bị"
            contentEl={
              <>
                Bạn có chắc muốn xoá thiết bị:{' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                  onClick={() => { }}
                >
                  {inventoryDetail?.name ?? ''}
                </span>
                ?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              try {
                const result = await ChargeHelper.API.requestDeleteChargeInventory(
                  inventoryDetail?.inventoryId
                );
                if (result && _.isBoolean(result)) {
                  ToastHelper.showSuccess('Xoá thiết bị thành công');
                  if (onDone) {
                    onDone();
                  }
                } else {
                  ToastHelper.showError(result || 'Xoá thiết bị thất bại');
                }
              } catch (error) {
                if (_.isString(error)) {
                  ToastHelper.showError(error);
                }
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
    },

    // MARK: ---- EXCEL ----
    Excel: {
      // tai xuong file excel
      showDialogDownloadExcelFile: (filter, onDownload = () => { }) => {
        AppCustomDialogHelper.show(
          'Tải xuống',
          <DialogDownloadExcelFile
            filter={filter}
            onDownload={onDownload}
          />,
          'md',
          false,
          true
        );
      },
    },

    // MARK: ---- NOTIFICATION ----
    Notification: {
      // hien thi dialog xac nhan an thong bao
      showDialogConfirmHideNotification: (notificationDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogHideNotification} />}
            title="Ẩn thông báo"
            contentEl={
              <>
                Bạc có chắc muốn ẩn thông báo {' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                  onClick={() => { }}
                >
                  {notificationDetail?.title}
                </span>
                {' '} không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Notification.requestUpdateNotification(
                notificationDetail?.notificationId,
                { public: 0 }
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Ẩn thông báo thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Ẩn thông báo thất bại');
              }
            }}
            confirmButtonRed={true}
          />,
          'md',
          true,
          true
        );
      },
      // hien thi dialog xac nhan hien thong bao
      showDialogConfirmShowNotification: (notificationDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogActiveAgency} />}
            title="Hiện thông báo"
            contentEl={
              <>
                Bạc có chắc muốn hiện thông báo {' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                  onClick={() => { }}
                >
                  {notificationDetail?.title}
                </span>
                {' '} không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Notification.requestUpdateNotification(
                notificationDetail?.notificationId,
                { public: 1 }
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Hiện thông báo thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Hiện thông báo thất bại');
              }
            }}
          />,
          'md',
          true,
          true
        );
      },
      // hien thi dialog xac nhan xoa thong bao
      showDialogConfirmDeleteNotification: (notificationDetail, onDone) => {
        AppCustomDialogHelper.show(
          '',
          <AgencySaleDialogView
            iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
            title="Xóa thông báo"
            contentEl={
              <>
                Bạc có chắc muốn xóa thông báo {' '}
                <span
                  className="cursor-pointer hover-opacity-60"
                  style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}
                  onClick={() => { }}
                >
                  {notificationDetail?.title}
                </span>
                {' '} không?
              </>
            }
            onCancel={() => {
              AppCustomDialogHelper.hide();
            }}
            onConfirm={async () => {
              AppCustomDialogHelper.hide();
              const result = await ChargeHelper.API.Notification.requestDeleteNotification(
                notificationDetail?.notificationId
              );
              if (result && _.isBoolean(result)) {
                ToastHelper.showSuccess('Xóa thông báo thành công');
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(result || 'Xóa thông báo thất bại');
              }
            }}
            confirmButtonRed={true}
          />,
          'md',
          true,
          true
        );
      },
    }
  },
};

export default ChargeHelper;
